/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-await-in-loop */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-param-reassign */
/* eslint-disable react/sort-comp */
/* eslint-disable no-console */
/* eslint-disable react/no-did-update-set-state */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ReactDOMServer from 'react-dom/server';
import ReactToPrint from 'react-to-print';
import QRcode from 'react-qr-code';
import { FormattedMessage } from 'react-intl';
import { Popover, PopoverBody } from 'reactstrap';
import moment from 'utils/moment';
import SectionHeader from '../../../components/sectionHeader';
import HeaderBack from '../../../components/headerBack';
import Loading from '../../../components/loading';
import Clickable from '../../../components/clickable/Clickable';
import CustomFieldDetail from '../../../components/customFields/CustomFieldDetail';
import { generateImges, generateQRcode, importAllImages, renderInfoForType, showGridTable } from '../../../utils/helpers';
import styles from '../forms.module.scss';
import { FORM_PUBLIC_STATUS } from '../../../constants/ModelStatus';
import { MYFORMS } from '../../../constants/RouterConstants';
import StepForm from './components/StepForm';
import StepInfoBox from './components/StepInfo';
import { S3Uploads, GetFileName } from '../../services';
import collaspeSty from './components/Approvals.module.scss';
import { actionClearForm, actionSaveTabView, approvalSendBack, fetchDataSourceFormDetails, approvalSendBackWithData, fetchFormAnswerDetails,
    getPortalFormSchema,
   getPortalusersForPortaUserlField, rejectApproval, submitApproval } from '../redux/actions';
import Collapsible from '../../../components/collapsible/Collapsible';
import Modal from '../../../components/modal';
import Button from '../../../components/button/button';
import CommentContainer from '../../../components/commenContainer';
import Separator from '../../../components/separator';
import DefaultPrintTemplate from './steps/Defaultprint/DefaultPrintTemplate';
import PulpoField from '../../../pulpo_visualizer/fields';
import CloseIcon from '../../../icons/closeIcon.svg';
import infoIcon from '../../../icons/info.svg';
import Panel from '../../../components/panel';
import generatePDF from './steps/Defaultprint/downloadPdf';
import { getFieldError, handleMultiFieldErrorList } from '../utils/helpers';

const splitExposeFieldData = obj => Object.entries(obj).reduce(
  (acc, [key, value]) => {
    if (key.startsWith('ex-')) {
      acc.exposeData[key] = value;
    } else {
      acc.resposeData[key] = value;
    }
    return acc;
  },
  { exposeData: {}, resposeData: {} }
);

const handleMultiGridSpecificFieldError = (field, formValues, handleSectionErrorMultiLevelField, handleMultiColumnGLS, form_data) => {
  let errorData = [];
  let isConditionallyVisible = true;
  if (field.conditional_field) {
    const conditionValues = field?.conditional_values;
    let fieldValue = form_data[field.conditional_field?.key];
    if (typeof fieldValue === 'boolean') fieldValue = fieldValue.toString();
    if (typeof fieldValue === 'object' && fieldValue?.level_0) {
      isConditionallyVisible = Object.values(fieldValue)?.filter(value => value !== '')?.join()
        === Object.values(conditionValues[0])?.filter(value => value !== '')?.join();
    } else {
      isConditionallyVisible = conditionValues.some(value => fieldValue?.includes(value?.value));
    }
  }
  Object.entries(field.multiple_fields).forEach(([key, config]) => {
    if (isConditionallyVisible) {
      const value = formValues[key];
      const isMultiLevel = config?.type?.key === 'multi_level';
      const isMandatory = config?.mandatory_multi_field;
      const fieldType = config?.type?.key;

      const isEmpty = value === null || value === undefined || value === ''
        || (Array.isArray(value) && value.length === 0);
      const field_type = fieldType === 'string' ? config?.validator : config?.inputType;
      const max_min = field_type || {};
      let errorMinMax = false;
      if (max_min?.type === 'min_max') {
        const length = value?.length ?? 0;
        const min = max_min?.minValue && +max_min?.minValue;
        const max = max_min?.maxValue && +max_min?.maxValue;

        if (min && length < min) {
          errorMinMax = true;
        } else if (max && length > max) {
          errorMinMax = true;
        }
      }
      if (isMultiLevel) {
        if ((isEmpty || handleSectionErrorMultiLevelField(config, value)) && isMandatory) {
          errorData.push(config.title);
        }
      } else if (isMandatory && isEmpty) {
        errorData.push(config.title);
      } else if (isMandatory && config?.type?.key === 'dataSource-ds8') {
        const showError = handleMultiColumnGLS(key, config, value);
        if (showError) {
          errorData.push(config.title);
        }
      } else if (['string', 'number'].includes(fieldType) && !isEmpty && errorMinMax) {
        errorData.push(config.title);
      }
    }
  });
  return errorData;
};

const MULTI_FIELD_DEFAULT_DATE_TYPES = [
  'date',
  'datetime',
  'dateWithSeconds',
  'datetimeWithSeconds',
  'time',
  'timeWithSeconds',
  'only_time',
  'only_time_with_seconds'
];

const hasMultiFieldDefault = fieldConfig => Boolean(fieldConfig?.default || fieldConfig?.type?.default);

const isMultiFieldDateLike = fieldConfig => MULTI_FIELD_DEFAULT_DATE_TYPES.includes(fieldConfig?.type?.key);

const getMultiFieldDefaultDateValue = fieldConfig => (
  hasMultiFieldDefault(fieldConfig) && isMultiFieldDateLike(fieldConfig)
    ? moment().format()
    : undefined
);

const normalizeMultiFieldRows = (rows, fieldMap) => {
  let normalizedRows = [];
  if (Array.isArray(rows)) {
    normalizedRows = rows;
  } else if (rows && typeof rows === 'object') {
    normalizedRows = [rows];
  }

  return normalizedRows.map((row) => {
    const nextRow = { ...(row || {}) };
    Object.entries(fieldMap || {}).forEach(([fieldKey, fieldConfig]) => {
      const fallbackValue = getMultiFieldDefaultDateValue(fieldConfig);
      if (fallbackValue !== undefined && (nextRow[fieldKey] === undefined || nextRow[fieldKey] === null || nextRow[fieldKey] === '')) {
        nextRow[fieldKey] = fallbackValue;
      }
    });
    return nextRow;
  });
};

const getApprovalMode = (step) => {
  const role_mode = step?.role_approval_mode;
  const user_mode = step?.user_approval_mode;
  const all_users_check = step?.all_users;
  if (role_mode === 'all' || user_mode === 'all') {
    return 'all';
  } if (role_mode === 'any' && user_mode === 'any') {
    return 'all';
  } if (role_mode) {
    return role_mode === 'user_per_role' ? 'all' : role_mode;
  } if (user_mode) {
    return user_mode;
  } if (all_users_check) {
    return 'all';
  }
  return 'any';
};
class MyformDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingStatus: false,
      actionDropdown: false,
      delPopup: false,
      historyPopup: false,
      expandedStatus: {},
      emailModal: false,
      newStepInfo: {
        attachments: [],
        completed_date: moment().format(),
        comment: '',
        completed_by: {}
      },
      hasInitialized: false,
      fieldErrors: {},
      isPrintPdf: false,
      showPrintTemplatesModal: false,
      collpaseAll: true,
      viewAllSteps: false,
      sectionId: '',
      formEntrySendBack: '',
      viewCustomPrint: false,
      openSendBackDetails: false,
      printDropdown: false,
      isPrintWithoutData: false,
      viewPrintOptions: false,
      errorsList: {},
      tafExpanded: false,
      printOptionSetting: '',
      errorListMCG: {}
    };
    this.images = importAllImages(
      require.context(
        '../../../icons/inspection-icons',
        false,
        /\.(png|jpe?g|svg)$/
      )
    );
    this.processStatus = {
      'in_progress': 'In Progress',
      'complete': 'Completed'
    };
    this.URL = MYFORMS;
    if (props?.match?.url?.includes('arff')) {
      this.URL = '/arff/forms';
    }
    this.printCustomTemplateRef = React.createRef();
    this.printComponentRef = React.createRef();
    this.printSecondComponentRef = React.createRef();
  }

  componentDidMount() {
    const {
      actionFetch,
      match,
      embedFormId,
      fetchPortalUsersList,
      fromAdp
    } = this.props;
    const detailId = match?.params?.id || embedFormId || fromAdp;
    actionFetch(detailId);
    fetchPortalUsersList();
    this.setState({ loadingStatus: true });
  }

  static getDerivedStateFromProps(props, state) {
    if (props.profile?.id && !state.newStepInfo?.completed_by?.id) {
      return {
        ...state,
        newStepInfo: {
          ...state.newStepInfo,
          completed_by: {
            id: props.profile.id,
            fullname: props.profile.fullname
          },
          completed_date: moment().format()
        }
      };
    }
    if (state?.currentStep && !state.hasInitialized) {
      const mutliFields = state?.currentStep?.fields?.filter(eachField => eachField.type === 'multi_field')|| [];
      const temp={};
      let tempErrors = {};
      if (mutliFields.length > 0) {
        mutliFields.forEach((eachMultiField) => {
          let data = {};
          const defaultValues = eachMultiField?.settings?.multiFields_default_values || {};
          const fixedRowFieldsCheck = eachMultiField?.fixed_Rows && eachMultiField?.repeat_field && Object.keys(defaultValues).length > 0;
           const exposeData = state.currentStep?.expose_data?.[eachMultiField.id];
          if (fixedRowFieldsCheck) {
            data = exposeData || Object.values(defaultValues);
          }

          if (fixedRowFieldsCheck) {
            temp[eachMultiField?.id] = data;
            let error = false;
            const multiFieldsErrors = {};
            if (eachMultiField?.required && eachMultiField?.multiple_fields) {
              const multipleFieldsKeys = Object.keys(eachMultiField?.multiple_fields || {});
              Object.keys(defaultValues).forEach((eachRow) => {
                error = multipleFieldsKeys.some(eachSubField => !(multipleFieldsKeys.includes(eachSubField)
                        && (defaultValues?.[eachRow]?.[eachSubField] && `${defaultValues?.[eachRow]?.[eachSubField]}`.length>0)));
                multiFieldsErrors[eachRow] = error;
              });
            }

            error = multiFieldsErrors && Object.keys(multiFieldsErrors).some(
              k => multiFieldsErrors[k] === true
            );

            tempErrors ={
              [eachMultiField.id]: error
            };
          }
        });
      }

        return {
          ...state,
          newStepInfo: {
            ...state.newStepInfo,
            ...temp
          },
        fieldErrors: {
          ...state.fieldErrors,
          ...tempErrors
        },
        hasInitialized: true
        };
    }
    return state;
  }

  componentDidUpdate(prevProps) {
    const {
      fetchAnswerAction,
      profile,
      formAnswer,
      formApproveAction,
      actionFetch,
      match,
      formRejectionAction,
      sendBackAction,
      formAnswerLinkedAction,
      actionFetchFormSchema
    } = this.props;
    const { loadingStatus, currentStep, init } = this.state;
    if (!currentStep && formAnswer?.id && profile?.id && !init) {
      if (formAnswer?.process?.status === 'complete') {
        this.setState({
          sectionId: 'details_step',
          isShowTabDetails: true,
          viewAllSteps: true,
          collpaseAll: true,
          useCollapseble: false
        });
      }
      this.getCurrentStep();
    }
    if (
      prevProps?.fetchAnswerAction?.loading === true
      && fetchAnswerAction?.loading === false
    ) {
      if (formAnswer?.parent_key) {
        actionFetchFormSchema(formAnswer?.parent_key);
      }
    }
    if (
      prevProps?.fetchAnswerAction?.loading === true
      && fetchAnswerAction?.loading === false
      && loadingStatus
    ) {
      this.setState({ loadingStatus: fetchAnswerAction.loading, showFormErrors: false });
      if (init) {
        this.getCurrentStep();
      }
      if (formAnswer?.process?.status === 'complete') {
        this.setState({
          sectionId: 'details_step',
          isShowTabDetails: true,
          viewAllSteps: true,
          collpaseAll: true,
          useCollapseble: false
        });
      }
    }

    if (prevProps.formRejectionAction?.loading === true
      && formRejectionAction?.loading === false
    ) {
      const detailId = match?.params?.id;
      this.setState({
        loadingStatus: true,
        requiredMap: undefined,
        newStepInfo: {},
        errorListMCG: {}
      });
      actionFetch(detailId);
    }

    if (prevProps.formApproveAction?.loading === true
      && formApproveAction?.loading === false
    ) {
      const detailId = match?.params?.id;
      this.setState({
        loadingStatus: true,
        requiredMap: undefined,
        newStepInfo: {},
        errorListMCG: {},
        sectionId: '',
        isShowTabDetails: true
      });
      actionFetch(detailId);
    }

    if (sendBackAction?.success === true && prevProps?.sendBackAction?.success === false) {
      const detailId = match?.params?.id;
      this.setState({
        sectionId: '',
        isShowTabDetails: true
      });
      actionFetch(detailId);
    }

    let fields = formAnswer?.form_version?.schema?.fields;
    if (fields) {
      fields.forEach((item) => {
        if (item.multiple_fields) {
          Object.keys(item.multiple_fields).forEach((key) => {
            if (Object.keys(item.multiple_fields[key]).length === 0) {
              delete item.multiple_fields[key];
            }
          });
        }
      });
    }
    if (prevProps.formAnswerLinkedAction?.loading === true && formAnswerLinkedAction?.loading === false) {
      this.setState({ loadingStatus: fetchAnswerAction?.loading });
    }
  }

  componentWillUnmount() {
    const { actionClearFormDetails, acitonGetTabView } = this.props;
    actionClearFormDetails();
    acitonGetTabView();
  }

  goToEditForm = (id) => {
    const { history } = this.props;
    history.push(`${this.URL}/${id}/edit_form`);
  };

  handleDelete = () => {
    this.setState({ loadingStatus: true });
  };


  duplicateFormEntry = (formAnswer) => {
    const { history } = this.props;
    if (formAnswer?.data && Object.keys(formAnswer?.data)?.length > 0) {
      Object.keys(formAnswer?.data).forEach((eachobject) => {
        if (((formAnswer?.data[eachobject]?.[0]?.entity_type === ('forms'))
          || (formAnswer?.data[eachobject]?.[0]?.entity_type === ('form_signature')))) {
          formAnswer.data[eachobject][0] = (formAnswer?.data[eachobject][0]?.name);
        }
      });
    }
    if (formAnswer?.key !== undefined) history.push(`${this.URL}/${formAnswer?.key}/duplicate`);
    window.location.reload();
  }

  handleDeletePopup = () => {
    const { delPopup } = this.state;
    this.setState({ delPopup: !delPopup, actionDropdown: false });
  };

  handleHistoryPopup = () => {
    this.setState({ historyPopup: !this.state.historyPopup });
  }

  formHistory = history => history && history.sort(
    (a, b) => new Date(b.date) - new Date(a.date)
  )

  closeModal = () => {
    this.setState({ emailModal: false });
  }

    resolveConcatValue = (field, answers, orderedFields) => {
  if (
    !field?.settings?.concatFields
    || !Array.isArray(field?.settings?.selectedContextualField)
    || !Array.isArray(orderedFields)
  ) {
    return null;
  }
  const selectedMap = {};
  field.settings.selectedContextualField.forEach((sf) => {
    selectedMap[sf.value] = sf;
  });
  const result = [];
  orderedFields.forEach((stateField) => {
    const selected = selectedMap[stateField.id];
    if (!selected) return;
    const val = answers?.[stateField.id];
    let output = '';
    if (val !== undefined && val !== null) {
      switch (selected?.type) {
        case 'address':
          output = typeof val === 'object'
            ? Object.values(val).filter(Boolean).join(' ')
            : String(val)
              .replace(/[^a-zA-Z0-9\s]/g, '')
              .replace(/\s+/g, ' ')
              .trim();
          break;
        case 'date':
        case 'datetime':
          output = new Date(val).toLocaleDateString();
          break;
        default:
          output = String(val);
      }
    }
    result.push(output);
  });
  return result.join(' ').replace(/\s+/g, ' ').trim();
};

applyConcatFields(fields) {
  if (!Array.isArray(fields) || fields.length === 0) return;
  const orderedFields = fields.filter(f => f?.id);
  this.setState((prev) => {
    const updatedAnswers = { ...prev.newStepInfo };
    fields.forEach((field) => {
      if (!field?.settings?.concatFields) return;
      const value = this.resolveConcatValue(field, updatedAnswers, orderedFields);
      if (value !== null && value !== undefined) {
        updatedAnswers[field.id] = value;
        this.handleInfoChanged('fieldErrors', field.id, false);
      }
    });
    return { newStepInfo: updatedAnswers };
  });
}

  handleInfoChanged = (section, id, value, category) => {
    const { conditionalFields, newStepInfo, currentStep, errorsList } = this.state;
    const field = currentStep?.fields?.find(eachField => eachField.id === id);
    if (section === 'newStepInfo' && conditionalFields?.[id]) {
      conditionalFields[id].map((item) => {
        if (currentStep.id === item?.conditional_step) {
          const conditionValues = item?.conditional_values;
          let fieldValue = value;
          let enabelCondition = false;
          if (typeof fieldValue === 'boolean') fieldValue = fieldValue.toString();
          if (typeof fieldValue === 'object' && fieldValue?.level_0) {
            enabelCondition = Object.values(fieldValue)?.filter(checkvalue => checkvalue !== '')?.join()
            === Object.values(conditionValues[0])?.filter(checkvalue => checkvalue !== '')?.join();
          } else {
            enabelCondition = conditionValues.some(checkvalue => fieldValue?.includes(checkvalue?.value));
          }
          if (item.required) {
            this.handleInfoChanged('fieldErrors', item.id,
              enabelCondition ? !newStepInfo?.[item?.id] : false);
          }
          if (item?.type !== 'header') {
            if (enabelCondition) {
              this.setState(prevState => ({
                [section]: {
                  ...prevState[section],
                  [id]: value,
                  [item.id]: prevState?.answers?.[item.id] || (item?.type === 'boolean' ? false : '')
                }
              }));
            } else {
              this.setState(prevState => ({
                [section]: {
                  ...prevState[section],
                  [id]: value,
                  [item.id]: item?.type === 'boolean' ? false : ''
                }
              }));
            }
          }
        }
        return item;
      });
      this.setState(prevState => ({
        [section]: {
          ...prevState[section],
          [id]: value
        }
      }));
    } else if (
    field?.type === 'string'
    && section === 'newStepInfo'
    && field?.validators
    && field?.validators?.[0]?.label === 'Email'
  ) {
    const convertValidtorValueToRegex = field.validators[0].value;
    const regexValue = new RegExp(convertValidtorValueToRegex);
    const tempErrors = { ...errorsList };

    if (field.validators[0]?.multiple_email) {
    const emailValue = value || '';
    const emailList = emailValue
      .split(',')
      .filter(e => typeof e === 'string')
      .map(e => e.trim());

    const invalidEmailCount = emailList?.filter(
      email => !regexValue?.test(email)
    ).length;
    const isValid = (!field?.required && emailValue === '') || invalidEmailCount === 0;
    tempErrors[field?.id] = isValid
      ? ''
      : getFieldError(
          field?.validators[0]?.label,
          field?.id,
          null,
          invalidEmailCount,
          field?.validators[0]?.multiple_email
        );

        this.setState(prevState => ({
             [section]: {
              ...prevState[section],
              [id]: value },
              errorsList: { ...tempErrors }
           }));
    } else {
      const invalidEmailCount = regexValue?.test(value) ? 0 : 1;
      tempErrors[field?.id] = invalidEmailCount === 0
        ? ''
        : getFieldError(
            field?.validators[0]?.label,
            field?.id,
            null,
            invalidEmailCount
          );
      this.setState(prevState => ({
               [section]: {
                ...prevState[section],
                [id]: value },
                errorsList: { ...tempErrors }
             }));
    }
    } else {
      this.setState((prevState) => {
        let nextSection = { ...prevState[section], [id]: value };
        switch (true) {
          case id === 'global_location':
            return {
              [section]: {
                ...prevState[section],
                [category]: { ...prevState[section][category], ...value }
              }
            };
          default:
            return { [section]: nextSection };
        }
      });
    }


    if (field?.type === 'multi_field' && value?.length > 0) {
      this.setState((prevState) => {
        const updatedErrorListMCG = handleMultiFieldErrorList(field, value, id, prevState);
        return { errorListMCG: updatedErrorListMCG };
      });
    }
    if (section === 'newStepInfo' && this.state.currentStep?.fields?.some(f => f?.settings?.concatFields)) {
      const fields = currentStep?.fields || [];
      this.setState({}, () => {
        this.applyConcatFields(fields);
      });
    }
  };

  handleUploadAttachments = async (attachments, entity) => {
    const attachmentIds = [];
    const newAttachments = [];
    const oldAttachments = [];
    attachments.forEach((e) => {
      if (!e.id) {
        newAttachments.push(e);
      } else if (e.id && e.name) {
        oldAttachments.push(e.name);
      }
    });
    let fileIds = '';
    if (newAttachments.length > 0) {
      fileIds = await GetFileName.getUploadFileName(newAttachments?.length);
    }
    if (fileIds) {
      await S3Uploads.uploadFiles(
        newAttachments,
        fileIds.filename,
        entity || 'form_approvals'
      ).then(() => {
        fileIds.filename.forEach((id) => {
          attachmentIds.push(id.toString());
        });
      });
    }
    if (oldAttachments.length > 0) {
      attachmentIds.push(...oldAttachments);
    }

    return attachmentIds;
  }

  handleCheckListAnswer = (fieldId, checkLisId, subCheckListKey, pass, remarks) => {
    const { newStepInfo, currentStep } = this.state;
    const version= currentStep?.fields?.length > 0 && currentStep?.fields.find(field => field.id===fieldId)?.version;
    const useCheckObj = {
      [fieldId]: {
        ...newStepInfo?.[fieldId],
        version,
        [checkLisId]: {
          ...newStepInfo?.[fieldId]?.[checkLisId],
          [subCheckListKey]: {
            ...newStepInfo?.[fieldId]?.[checkLisId]?.[subCheckListKey],
            check_lilst_status: pass,
            checklist_remarks_list: remarks
          }
        }
      }
    };
    this.setState(prevState => ({
      newStepInfo: {
        ...prevState.newStepInfo,
        ...useCheckObj
      }
    }));
    this.handleInfoChanged('fieldErrors', fieldId, false);
  }

  handleSectionErrorMultiLevelField = (v, answer={}) => {
    let level_1 = ''; let level_2 = '';
    let levelRes = true;
    let values = v?.values;
    let ans_level_0 = 'level_0'; let ans_level_1 = 'level_1'; let ans_level_2 = 'level_2';

   if (answer[ans_level_0]) {
    for (let v1 in values) {
      if (values[v1].title === answer[ans_level_0]) {
        level_1 = values[v1]?.level_1 || '';
        levelRes = false;
      }
      if (level_1) {
        for (let v2 in level_1) {
          if (level_1[v2].title === answer[ans_level_1]) {
            level_2 = level_1[v2].level_2 || '';
            levelRes = false;
            break;
          } else {
            levelRes = true;
          }
        }
        if (level_2) {
          for (let v3 in level_2) {
            if (level_2[v3].title === answer[ans_level_2]) {
              levelRes = false;
              break;
            } else {
              levelRes = true;
            }
          }
        }
      }
    }
    }
    return levelRes;
  }

  handleMultiColumnGLS = (fieldId, field, ans_values) => {
    const { dataSourceValues } = this.props;
    const specificFieldValues = dataSourceValues[fieldId];
    let finalError;

    for (const [key, value] of Object.entries(ans_values)) {
      if (key === 'level_0') {
        let levelZeroValues = specificFieldValues?.filter(
          levelZeroValue => (levelZeroValue?.name === value)
        );
        if (levelZeroValues?.length === 0) {
          finalError = field?.mandatory_multi_field || false;
        } else if (value !== '' && levelZeroValues?.length > 0) {
          let levelOneValues = levelZeroValues[0].location_levels;
          if (levelOneValues?.length === 0) {
            finalError = false;
          } else {
            finalError = field?.mandatory_multi_field || false;
          }
        }
      } else if (key === 'level_1') {
        let levelZeroValues = specificFieldValues.filter(
          val => (val?.name === ans_values?.level_0)
        );
        let levelOneValues = [];
        let levelTwoValues = [];
        if (levelZeroValues.length > 0) {
          levelOneValues = levelZeroValues[0].location_levels;
        }
        if (ans_values?.level_0 && levelOneValues?.length > 0) {
          levelOneValues = levelOneValues.filter(
            val => val?.title === value
          );
          if (levelOneValues.length === 0) {
            finalError = field?.mandatory_multi_field || false;
          } else if (value !== '' && levelOneValues?.length > 0) {
            levelTwoValues = levelOneValues[0].level_1;
            if (levelTwoValues?.length === 0) {
              finalError = false;
            } else {
              finalError = field?.mandatory_multi_field || false;
            }
          }
        }
      } else if (key === 'level_2') {
        let levelZeroValues = specificFieldValues.filter(
          val => (val?.name === ans_values?.level_0)
        );
        let levelOneValues = [];
        let levelTwoValues = [];
        let levelThreeValues = [];
        if (levelZeroValues.length > 0) {
          levelOneValues = levelZeroValues[0].location_levels;
        }
        if (ans_values?.level_0 && ans_values?.level_1 && levelOneValues?.length > 0) {
          levelTwoValues = levelOneValues.filter(
            val => (val?.title === ans_values?.level_1)
          );
          if (levelTwoValues.length === 0) {
            finalError = field?.mandatory_multi_field || false;
          } else if (value !== '' && levelThreeValues?.length > 0) {
            levelThreeValues = levelTwoValues[0].level_1;
            if (levelThreeValues?.length === 0) {
              finalError = false;
            } else {
              finalError = field?.mandatory_multi_field || false;
            }
          }
        }
      } else if (key === 'level_3') {
        let levelZeroValues = specificFieldValues.filter(
          val => (val?.name === ans_values?.level_0)
        );
        let levelOneValues = [];
        let levelTwoValues = [];
        let levelThreeValues = [];
        if (levelZeroValues.length > 0) {
          levelOneValues = levelZeroValues[0].location_levels;
        }
        if (ans_values?.level_0 && ans_values?.level_1 && ans_values?.level_2 && levelOneValues?.length > 0) {
          levelTwoValues = levelOneValues.filter(
            val => (val?.title === ans_values?.level_1)
          );
          levelTwoValues = levelTwoValues[0].level_1;
          levelTwoValues = levelTwoValues.filter(
            val => (val?.title === ans_values?.level_2)
          );
          levelThreeValues = levelTwoValues[0].level_2;
          if (levelThreeValues.length === 0) {
            finalError = false;
          } else if (value !== '' && levelThreeValues?.length > 0) {
            finalError = false;
          }
        }
      }
    }

    return finalError;
  };

  handleMultiFieldIndividualError = () => {
    const {
      newStepInfo: {
        comment,
        completed_by,
        completed_date,
        attachments,
        ...data
      },
      currentStep: { fields }
    } = this.state;
    let finalErrorData = [];
    if (fields?.length > 0) {
      fields.forEach((field) => {
        if (field.type === 'multi_field' && field.multiple_fields && !field.repeat_field) {
          const formValues = data[field.id]?.[0];
          if (!formValues) return;

          finalErrorData = [...finalErrorData, ...handleMultiGridSpecificFieldError(
            field, formValues, this.handleSectionErrorMultiLevelField, this.handleMultiColumnGLS,
            data
          )];
        } else if (field.type === 'multi_field' && field.multiple_fields && field.repeat_field) {
          const formValues = data[field.id];
          if (!formValues) {
            finalErrorData = [...finalErrorData, ...handleMultiGridSpecificFieldError(
              field, {}, this.handleSectionErrorMultiLevelField, this.handleMultiColumnGLS,
              data
            )];
          } else {
            formValues.forEach((formValue) => {
              finalErrorData = [...finalErrorData, ...handleMultiGridSpecificFieldError(
                field, formValue, this.handleSectionErrorMultiLevelField, this.handleMultiColumnGLS,
                data
              )];
            });
          }
        }
      });
    }
    return finalErrorData;
  }

  handleSubmitApprove = async (isDraft) => {
    const {
      newStepInfo: {
        comment,
        completed_by,
        completed_date,
        attachments,
        ...data
      },
      fieldErrors,
      signatureFields,
      currentStep,
      errorListMCG,
      errorsList
    } = this.state;
    const { actionApprovalStep, formAnswer, profile } = this.props;
    if (currentStep?.fields?.length> 0) {
      currentStep.fields.forEach((field) => {
      if (field.type === 'toggle' && Object.prototype.hasOwnProperty.call(fieldErrors, field.id)) {
       fieldErrors[field.id]=false;
     }
     if (field.type === 'dataSource' && field.dataSourceID === 'ds13') {
      fieldErrors[field.id]=false;
    }
     });
   }
    const noErrors = isDraft || fieldErrors && Object.keys(fieldErrors).every(
      k => fieldErrors[k] === false
    );
    const multiFieldError = this.handleMultiFieldIndividualError();
    const errorValues = Object.values(errorsList).every(eachError => eachError === '');
    const checkOtherValidation = isDraft ? true : multiFieldError?.length === 0 && Object.keys(errorListMCG)?.length === 0 && errorValues;
    if (noErrors && checkOtherValidation) {
      this.setState({ loadingStatus: true });
      const attachmentFields = currentStep?.fields?.filter(schemaField => (
        schemaField?.type === 'attachments' || schemaField?.type === 'multi_field'
      )) || [];
      const response = { ...data };
      if (attachmentFields?.length > 0) {
        for (let index = 0; index < attachmentFields.length; index++) {
          const attachmentField = attachmentFields[index]?.id;
          const schemaField = attachmentFields[index];
          if (schemaField?.type === 'attachments' && response[attachmentField]?.length > 0) {
            response[attachmentField] = await this.handleUploadAttachments(response[attachmentField], 'portal_form_approval');
          } else if (schemaField?.type === 'multi_field') {
            const multiAttachmentFields = schemaField?.multiple_fields
              && Object.keys(schemaField?.multiple_fields)?.filter(f => schemaField?.multiple_fields?.[f]?.type?.key === 'attachments');
            if (multiAttachmentFields?.length > 0) {
              for (let multiIndex = 0; multiIndex < multiAttachmentFields?.length; multiIndex++) {
                for (let multiDataIndex = 0; multiDataIndex < response?.[schemaField?.id]?.length; multiDataIndex++) {
                  const attachmentIds = response?.[schemaField?.id]?.[multiDataIndex]?.[multiAttachmentFields[multiIndex]] || [];
                  if (attachmentIds?.length > 0) {
                    response[schemaField?.id][multiDataIndex][multiAttachmentFields[multiIndex]] = attachmentIds?.map(attach => (
                      attach?.attachmentUploadId || attach?.name
                    ));
                  }
                }
              }
            }
          }
        }
      }
      if (signatureFields?.length > 0) {
        for (let i = 0; i < signatureFields.length; i++) {
          const signatureField = signatureFields[i];
          if (response?.[signatureField]?.[0]?.id) {
            response[signatureField] = await this.handleUploadAttachments(response[signatureField], 'form_signature');
          } else if (response?.[signatureField]) {
            response[signatureField] = await this.handleUploadAttachments([response[signatureField]], 'form_signature');
          }
        }
      }

      const { exposeData, resposeData } = splitExposeFieldData(response);
      const formData = new FormData();
      if (comment) {
        formData.append('comment', comment);
      }
      formData.append('completed_date', completed_date);
      formData.append('completed_by', JSON.stringify(completed_by));
      formData.append('status', isDraft ? 'draft': 'complete');
      formData.append('step_id', currentStep?.id);
      formData.append('data', JSON.stringify(resposeData));
      formData.append('expose_data', JSON.stringify(exposeData));
      formData.append('source', 'portal');
      formData.append('portal_tenant', profile.current_tenant?.name);
      let currentApprove;

      if (getApprovalMode(currentStep) === 'all') {
        currentApprove = formAnswer?.process?.approvals?.find(
          a => ((a.step_id === currentStep?.id || (!currentStep?.id && a.step_id === currentStep?.id))
            && a?.logged_by?.id === profile?.id)
        );
      } else {
        currentApprove = formAnswer?.process?.approvals?.find(
          a => a.step_id === currentStep?.id || (!currentStep?.id && a.step_id === currentStep?.id)
        );
      }

      if (currentApprove) {
        formData.append('approval_id', currentApprove?.id);
      }
      // SEND TO PAYLOAD WHEN THERE IS A STEP WITH form_data_user_dropdown (FORM DATS SOURCE SYSTEM USER FIELD) APPROVAL
      formData.append('step_assignees', JSON.stringify(currentStep?.assigned_persons));

      if (attachments?.length > 0) {
        const attachmentIds = await this.handleUploadAttachments(attachments, 'form_approval');
        attachmentIds.forEach((attachment) => {
          formData.append('attachments', attachment);
        });
      }
      actionApprovalStep(formData, formAnswer?.id);
    } else {
      this.setState({ showFormErrors: true });
    }
  }

    // CHECK THE CONDITIONAL FIELD VALUE IS SATISFIED OR NOT
    handleGetStepInfo = (field, form_entry_data, stepInfo) => {
      const { formAnswer } = this.props;
      const { sectionId } = this.state;
      let isValue = false;
      const conditionalKey = field?.conditional_field?.key;
      const conditionalStep = field?.conditional_step;
      let haveAnswers = stepInfo?.find(eachInfo => eachInfo.step_id === conditionalStep)?.data || {};
      let useCurrentStepFilter = formAnswer?.process.current_step;
      if (formAnswer?.process?.current_step?.split(',')?.length > 1) {
        useCurrentStepFilter = sectionId !== '' ? sectionId : formAnswer?.process?.current_step?.split(',')?.[0];
      }
      const approvalInfo = stepInfo?.find(stInfo => stInfo.step_id === useCurrentStepFilter) || {};
      if (conditionalStep === 'form_entry') {
        haveAnswers = form_entry_data;
      }
      if (typeof haveAnswers[conditionalKey] === 'string') {
        isValue = field?.conditional_values.filter(
          value => haveAnswers[conditionalKey] === value.value
        ).length > 0;
      }
      if (typeof haveAnswers[conditionalKey] === 'object') {
        if (Array.isArray(haveAnswers[conditionalKey])) {
          // Handle the case where checkConditionalVal is an array
          isValue = field?.conditional_values.some(
              value => haveAnswers[conditionalKey].indexOf(value.value) !== -1
          );
      } else if (haveAnswers[conditionalKey]?.level_1) {
          // Handle the case where checkConditionalVal is an object with level properties
          isValue = Object.values(haveAnswers[conditionalKey])
          ?.filter(value => value !== '')
          ?.join()
          === Object.values(field.conditional_values[0])
          ?.filter(value => value !== '')
          ?.join();
      }
    } else if (typeof haveAnswers[conditionalKey] === 'boolean') {
        isValue = field?.conditional_values.filter(
          value => (
            haveAnswers[conditionalKey].toString() === value?.value
          )
        ).length > 0;
      }
      if (isValue && approvalInfo?.id && approvalInfo?.data?.[field.id] !== '') {
        isValue = false;
      }

      return isValue;
    }

  handleCustomFields = (currentStep, fields) => {
    let requiredMap = {};
    let fieldErrors = {};
    let errorListMCG = {};
    const conditionalFields = {};
    const signatureFields = [];
    const { profile, formAnswer } = this.props;
    let { newStepInfo } = this.state;
    const info = formAnswer?.process?.approvals?.find(i => i.step_id===currentStep?.id && i?.logged_by?.id === profile?.id);
    if (info) {
      newStepInfo ={ attachments: info.attachments,
        comment: info.comment,
        completed_date: moment().format(),
        completed_by: { id: info.logged_by?.id, fullname: info.logged_by?.fullname },
        ...info.data,
        ...currentStep?.expose_data
        };
    }
    if (currentStep?.expose_data) {
      newStepInfo = {
        ...newStepInfo,
        ...currentStep?.expose_data
      };
    }
    let ssi_data = false;
    if (fields?.length > 0) {
      const stepsAnswers = formAnswer.process?.approvals || [];
      const havingRole = profile?.roles?.filter(
        e => e?.meta_data?.ssi_data === true || e.name === 'System Admin'
      ) || [];
      if (havingRole.length > 0) ssi_data = true;
      if (fieldErrors && Object.keys(fieldErrors).length === 0) {
        fields.forEach((detailField) => {
          // Fields disabled for portal users are hidden in myforms UI,
          // so they must not participate in required/error validation.
          if (detailField?.disable_for_portal === true) {
            return;
          }
          const dafultValues = detailField?.settings?.multiFields_default_values || {};
          const exposeData = currentStep?.expose_data?.[detailField.id];
          const fixedRowFiledsCheck = detailField?.type === 'multi_field' && detailField?.fixed_Rows && detailField?.repeat_field
            && Object.keys(dafultValues)?.length > 0;
          const data = exposeData || Object.values(dafultValues);
          if (detailField.type === 'boolean') {
            newStepInfo[detailField.id] = newStepInfo[detailField.id] || false;
          }
          if (detailField?.type === 'multi_field' && !detailField?.repeat_field && Object.keys(detailField?.multiple_fields || {})?.length > 0) {
            let new_obj = Object.entries(detailField?.multiple_fields || {})
              // eslint-disable-next-line no-unused-vars
              ?.filter(([key, value]) => value?.type?.default)
              ?.map(([key]) => ({ [key]: moment().format() }));
             if (new_obj.length > 0) {
            let combinedObject = Object.assign({}, ...new_obj);
            newStepInfo[detailField.id] = [combinedObject];
          }
        }
          if (fixedRowFiledsCheck && data) {
            errorListMCG = handleMultiFieldErrorList(detailField, data, detailField.id, {});
            newStepInfo[detailField.id] = data;
            let error = false;
            const multiFieldsErrors = {};
            if (detailField?.required && detailField?.multiple_fields) {
              const multipleFieldsKeys = Object.keys(detailField?.multiple_fields);
              Object.keys(dafultValues).forEach((eachRow) => {
                error = multipleFieldsKeys.some(eachSubField => !(multipleFieldsKeys.includes(eachSubField)
                  && (dafultValues?.[eachRow]?.[eachSubField] && `${(dafultValues?.[eachRow]?.[eachSubField])}`.length > 0)));
                multiFieldsErrors[eachRow] = error;
              });
            }

            error = multiFieldsErrors && Object.keys(multiFieldsErrors).some(
              k => multiFieldsErrors[k] === true
            );

            fieldErrors = {
              ...fieldErrors,
              [detailField.id]: error
            };
          }
          if (detailField.type !== 'header') {
            requiredMap = {
              ...requiredMap,
              [detailField.id]: detailField.required
            };
            if (!detailField.conditional) {
              if (info && info?.data[detailField.id]) {
                fieldErrors = {
                  ...fieldErrors,
                  [detailField.id]: false
                };
              } else {
                let errorValue;

                if (!ssi_data && detailField.type === 'ssi_field') {
                  errorValue = false;
                } else if (currentStep.expose_data?.[detailField.id] ?? null) {
                  errorValue = false;
                } else if (detailField?.type === 'risk_assess') {
                  errorValue = false;
                } else {
                  errorValue = detailField.required;
                }

                fieldErrors = {
                  ...fieldErrors,
                  [detailField.id]: errorValue
                };
              }
            } else {
              if (conditionalFields[detailField?.conditional_field?.key]) {
                conditionalFields[
                  detailField?.conditional_field?.key
                ] = [...conditionalFields[detailField?.conditional_field?.key], detailField];
              } else {
                conditionalFields[
                  detailField?.conditional_field?.key
                ] = [detailField];
              }
              // HANDLE WORKFLOW STEP CONDITIONAL FIELDS -- FIELD ERRORS
              const stepErrors = this.handleGetStepInfo(detailField, formAnswer?.data, stepsAnswers);
                fieldErrors = {
                  ...fieldErrors,
                  [detailField.id]: stepErrors
                };
                if ((detailField?.conditional && detailField.conditional_field?.type === 'boolean'
                  && detailField.conditional_values?.some(i => i.value === 'false')
                )) {
                  fieldErrors = {
                  ...fieldErrors,
                    [detailField.id]: detailField.required
                };
              }
            }
          }
          if (detailField.type === 'signature') signatureFields.push(detailField.id);
        });
      } else {
        fields.forEach((detailField) => {
          if (detailField?.disable_for_portal === true) {
            return;
          }
          if (detailField.type !== 'header') {
            requiredMap = {
              ...requiredMap,
              [detailField.id]: detailField.type === 'signature' ? false : detailField.required
            };
            if (detailField.conditional) {
              if (conditionalFields[detailField?.conditional_field?.key]) {
                conditionalFields[
                  detailField?.conditional_field?.key
                ] = [...conditionalFields[detailField?.conditional_field?.key], detailField];
              } else {
                conditionalFields[
                  detailField?.conditional_field?.key
                ] = [detailField];
              }
            }
            const stepErrors = this.handleGetStepInfo(detailField, formAnswer?.data, stepsAnswers);
              fieldErrors = {
                ...fieldErrors,
                [detailField.id]: stepErrors
              };
          }
        });
      }
    }
    this.setState({
      requiredMap,
      fieldErrors,
      errorListMCG,
      conditionalFields,
      signatureFields,
      currentStep,
      newStepInfo,
      init: true
    });
  }

  getSortedSteps = (steps = []) => {
    const stepMap = new Map();
    const graph = new Map();
    const inDegree = new Map();

    steps.forEach((step) => {
      stepMap.set(step.id, step);
      inDegree.set(step.id, 0);
      graph.set(step.id, []);
    });

    // Build graph and compute in-degrees
    steps.forEach((step) => {
      if (step.next_steps) {
        step.next_steps.forEach((nextId) => {
          if (graph.has(step.id)) {
            graph.get(step.id).push(nextId);
          }
          inDegree.set(nextId, (inDegree.get(nextId) || 0) + 1);
        });
      }
    });

    // Start with nodes with no incoming edges (i.e., in-degree 0)
    const queue = [];
    inDegree.forEach((deg, id) => {
      if (deg === 0) queue.push(id);
    });

    const sorted = [];

    while (queue.length > 0) {
      // Sort queue for consistent output (by node_id)
      queue.sort((a, b) => {
        const aId = parseInt(stepMap.get(a)?.node_id || '0', 10);
        const bId = parseInt(stepMap.get(b)?.node_id || '0', 10);
        return aId - bId;
      });

      const current = queue.shift();
      sorted.push(stepMap.get(current));

      graph.get(current).forEach((neighbor) => {
        inDegree.set(neighbor, inDegree.get(neighbor) - 1);
        if (inDegree.get(neighbor) === 0) {
          queue.push(neighbor);
        }
      });
    }

    // Add orphan nodes (not connected to graph)
    const sortedIds = new Set(sorted.map(s => s.id));
    const orphanSteps = steps.filter(step => !sortedIds.has(step.id));

    return [...sorted, ...orphanSteps.sort((a, b) => {
      const aId = parseInt(a.node_id || '0', 10);
      const bId = parseInt(b.node_id || '0', 10);
      return aId - bId;
    })];
  };

  getCurrentStep = (isTabView) => {
    const { formAnswer, profile } = this.props;
    const approvalsSchema = formAnswer?.form_version?.process_def?.approvals;
    const steps = approvalsSchema?.steps || [];
    const { sectionId, formEntrySendBack } = this.state;
    let currentStep = formAnswer?.process?.current_step;
    if (formAnswer?.process?.status === 'in_progress') {
      if (formAnswer?.process?.current_step === 'step_1' && !formEntrySendBack) {
        this.setState({
          formEntrySendBack: formAnswer?.process?.current_step,
          openSendBackDetails: true
        });
      } else if (formAnswer?.process?.current_step?.length > 0) {
        let curStep = formAnswer?.process?.current_step?.split(',');
        currentStep = steps?.filter(step => (
          curStep?.indexOf(step?.id) !== -1
          && step?.assignees?.filter(assignee => (
            (assignee?.type === 'initiator' && formAnswer?.created_by?.id === profile?.id)
            || (assignee?.type === 'portal_signatory' && profile?.permissions?.is_portal_sign)
            || (assignee?.type === 'portal_user'
               && step?.assigned_persons?.filter(user => user.id === profile?.id)?.length > 0)
            || (assignee?.type === 'user'&& assignee?.id === profile?.id)
          ))?.length > 0
        )) || {};
        if (currentStep?.length > 0) {
          currentStep = isTabView ? currentStep?.find(newStep => newStep.id === sectionId) : currentStep?.[0];
        }
      } else {
        currentStep = steps?.filter(step => step?.prev_steps?.length === 0)?.[0] || {};
      }
      if (sectionId === '') {
        this.setState({
          sectionId: currentStep?.id || 'details_step',
          isShowTabDetails: true,
          viewAllSteps: false,
          collpaseAll: true,
          useCollapseble: false
        });
      }
    }
    if ((('process' in formAnswer && formAnswer.process && Object.values(formAnswer?.process)?.length === 0) || formAnswer.process === null)) {
      this.setState({
        sectionId: 'details_step'
      });
    }
    this.handleCustomFields(currentStep, currentStep?.fields);
  }

  checkVisibility = (stepId) => {
    const { formAnswer, profile } = this.props;
    const allSteps = formAnswer?.form_version?.process_def?.approvals?.steps || [];
    const considerSteps = formAnswer?.process?.approvals?.map(approval => approval?.step_id);
    const current_step = formAnswer?.process?.current_step?.split(',') || [];
    considerSteps.push(...current_step);
    let visible = false;

    // getting all approvals which are assigned to me and amy role
    const assignedSteps = allSteps?.filter(step => (
      step?.assigned_persons?.filter(person => (
        (person?.type === 'initiator' && formAnswer?.created_by?.id === profile?.id)
        || (person?.type === 'portal_signatory' && profile?.permissions?.is_portal_sign)
        || (person?.type === 'portal_user'
          && step?.assigned_persons?.filter(user => user.id === profile?.id)?.length > 0)
        || (person?.type === 'user'&& person?.id === profile?.id)
      ))?.length > 0
    ));
    assignedSteps.forEach((assignedStep) => {
      if (considerSteps?.indexOf(assignedStep?.id) !== -1 && assignedStep?.id === stepId) {
        // if the checking step is assigned to me then display
        visible = true;
      } else if (considerSteps?.indexOf(assignedStep?.id) !== -1 && assignedStep?.visibility?.[stepId]?.view === true) {
        // if the checking step view permission is given to any one of my assigned then display
        visible = true;
      }
    });
    return visible;
  }

  // CUSTOM PRINT FIELD TITLE FUNCTION
  handlePrintFieldName = (fieldId, optionVal) => {
    const { formAnswer } = this.props;
    let schemaFields = [];
    let viewObj = {};
    if (formAnswer && Object.keys(formAnswer)?.length > 0) {
      schemaFields = formAnswer?.form_version?.schema?.fields;
      viewObj = schemaFields.find(eachField => eachField.id === fieldId);
      if (viewObj?.type === 'select' && optionVal) {
        return viewObj?.values?.find(checkVal => checkVal.key === optionVal)?.value;
      }
      return viewObj?.title;
    }
    return '';
  }

  // CUSTOM PRINT FIELD VALUES FUNCTION
  handleFieldValue = (fieldId, optionVal) => {
    const { formAnswer } = this.props;
    let schemaFields = [];
    let viewObj = {};
    if (formAnswer && Object.keys(formAnswer)?.length > 0) {
      schemaFields = formAnswer?.form_version?.schema?.fields;
      viewObj = schemaFields.find(eachField => eachField.id === fieldId);
      if (viewObj?.type === 'select' && optionVal) {
        return formAnswer?.data?.[viewObj?.id] === optionVal ? 'checked' : '';
      }
      if (viewObj?.type === 'multiselect' && optionVal) {
        return formAnswer?.data?.[viewObj?.id]?.filter(e => e === optionVal).length > 0 ? 'checked' : '';
      }
      if (viewObj?.type === 'signature') {
        return formAnswer?.data?.[viewObj?.id]?.[0]?.url;
      }
      if (viewObj?.type === 'date') {
        return renderInfoForType(viewObj, formAnswer?.data?.[viewObj?.id], null, null);
      }
      if (viewObj?.type === 'time') {
        let timeObj = renderInfoForType(viewObj, formAnswer?.data?.[viewObj?.id], null, null);
          if (optionVal === 'noampm' && timeObj.includes('AM')) {
            return timeObj.replace(' AM', '');
          }
          if (optionVal === 'noampm' && timeObj.includes('PM')) {
            return timeObj.replace(' PM', '');
          }
          if (optionVal === 'am' && timeObj.includes('AM')) {
            return 'checked';
          }
          if (optionVal === 'pm' && timeObj.includes('PM')) {
            return 'checked';
          }
          return renderInfoForType(viewObj, formAnswer?.data?.[viewObj?.id], null, null);
      }
      return formAnswer?.data?.[viewObj?.id];
    }
    return null;
  }

  handleReject = ({ remarks, rejected_date }) => {
    const {
      actionRejectApproval,
      formAnswer
    } = this.props;
    const { currentStep } = this.state;
    this.setState({ loadingStatus: true });
    const data = {
      step_title: currentStep?.title,
      step_id: currentStep?.id,
      source: 'portal',
      remarks,
      rejected_date
    };
    actionRejectApproval(formAnswer?.id, data);
  }

  handleSendBack = async (useRemarksObj) => {
    this.setState({ loadingStatus: true });
    const {
      formAnswer,
      actionSendBack,
      actionSendBackWithData
    } = this.props;
    const { currentStep,
      newStepInfo: {
        comment,
        completed_by,
        completed_date,
        attachments,
        ...data
      }
     } = this.state;
     let entityData = {
      'current_step_id': currentStep.id,
       step_title: currentStep.title,
       source: 'portal',
       ...useRemarksObj
      };
     if (currentStep?.send_back_with_data) {
      entityData = {
        ...entityData,
        completed_date,
        completed_by,
        status: 'send_back_loop',
        step_id: currentStep?.id,
        data,
        expose_data: {},
        step_assignees: currentStep?.assigned_persons
      };
       if (comment) {
        entityData.comment = comment;
      }
      if (attachments?.length > 0) {
        const attachmentIds = await this.handleUploadAttachments(attachments, 'form_approval');
        entityData.attachments = attachmentIds;
      }
      actionSendBackWithData(formAnswer.id, entityData);
      return;
    }
    actionSendBack(formAnswer.id, entityData);
    this.setState({ newStepInfo: {}, currentStep: {}, errorListMCG: {} });
  }

  displayFormEntry = () => {
    const { formAnswer, profile } = this.props;
    const allSteps = formAnswer?.form_version?.process_def?.approvals?.steps || [];
    const approvalIds = formAnswer?.process?.approvals?.map(approval => approval?.step_id) || [];
    const current_step = formAnswer?.process?.current_step?.split(',') || [];
    approvalIds.push(...current_step);
    let visible = true;

    // getting all approvals which are assigned to me and amy role
    const assignedSteps = allSteps?.filter(step => (
      step?.assigned_persons?.filter(person => (
        (person?.type === 'initiator' && formAnswer?.created_by?.id === profile?.id)
        || (person?.type === 'portal_user'
          && step?.assigned_persons?.filter(user => user.id === profile?.id)?.length > 0)
        || (person?.type === 'user'&& person?.id === profile?.id)
      ))?.length > 0
    ));
    assignedSteps.forEach((assignedStep) => {
      if (approvalIds?.indexOf(assignedStep?.id) !== -1 && assignedStep?.visibility?.form_entry?.hide === true) {
        // if the checking step hide permission is given to any one of my assigned then hide
        visible = false;
      }
    });
    return visible;
  }

  handleShowTab = (section) => {
    let isPending = false;
    const { formAnswer } = this.props;
    if (formAnswer?.process?.current_step?.split(',')?.length > 0) {
      isPending = true;
    }
    if (!formAnswer?.process?.info?.path?.includes(section)) {
      isPending = true;
    }
    this.setState({ sectionId: section,
      isShowTabDetails: true,
      collpaseAll: false,
      viewAllSteps: false,
      fieldErrors: {},
      newStepInfo: {},
      errorListMCG: {}
      }, () => this.getCurrentStep(isPending));
  }

  handleAutoApprovalStep = (checkStep) => {
    let isAutoApproval = false;
    // CHECK AUTO APPROVAL AND CHECK 'HIDE AUTO APPROVAL STEP IN DETAIL VIEW' CHECKBOX IN SETP LEVEL
    if (checkStep?.reminder?.auto_approval && checkStep?.reminder?.disableAutoApprovalStepInDetailView) {
      isAutoApproval = true;
    }
    return isAutoApproval;
  }

  handleShowStepVisible = (step, stepStatus) => {
    const { sectionId } = this.state;
    const { formAnswer } = this.props;
    return (
      <>
      {/* DON'T SHOW AUTO APPROVAL STEP IF THIS CONDITION IS TRUE */}
      {!this.handleAutoApprovalStep(step)
      && (
        <div className={collaspeSty.processStep}
          role="button" tabIndex={0}
          onClick={() => this.handleShowTab(step?.id)}
          onKeyPress={() => this.handleShowTab(step?.id)}
          style={{ borderTop: '0px solid var(--border-default)',
                background: sectionId === step?.id ? 'aliceblue' : 'none',
                cursor: 'pointer',
                display: 'flex',
                flexDirection: 'column' }}
        >
          <div
            style={{ cursor: 'pointer', position: 'relative', display: 'flex', alignItems: 'center' }}
          >
            <div>
              {stepStatus === 'awaiting' && (
                <span className={styles.awaitingDot} />
              )}
              {stepStatus === 'pending' && (
              <span className={styles.pendingDot} />
              )}
              {stepStatus === 'completed' && (
                <span className={styles.approvalDot} />
              )}
              {stepStatus === 'rejected' && (
                <span className={styles.rejectDot} />
              )}
              {stepStatus === 'sendBack' && (
                <span className={styles.sendBackDot} />
              )}
            </div>
            <h3 style={{ margin: '0px', wordBreak: 'break-all', width: '85%' }}>
              {step?.title}
            </h3>
            <img src={infoIcon} alt="infoIcon"
              id={`popover${step?.id}`}
              onMouseEnter={() => this.setState({ popoverData: { isOpenPopover: true, selectedPopStep: step?.id } })}
            />
          </div>
          {this.handleProcessSteps(step?.id)
          && formAnswer?.process?.current_step?.split(',')?.[0] !== step.id
          && formAnswer?.process?.approvals?.find(eachApp => eachApp?.step_id === step.id)?.step_id
          && !formAnswer?.process?.current_step?.split(',')?.includes(step.id)
          && (
            <div style={{ padding: '0px 20px' }}>
              {!formAnswer?.process?.approvals?.find(eachApp => eachApp?.step_id === step.id)?.logged_by
              && (<p style={{ color: '#8C9EA7' }}>Auto Approved</p>)}
            </div>
          )}
          {this.handlePophover(step?.id, 'pending', false, stepStatus)}
        </div>
      )}
      </>
    );
  }

  handleGetCompanyName = (approvalUser) => {
    const { portal_users_list, formAnswer } = this.props;
    const tenantNames = portal_users_list?.find(user => user.id === approvalUser.id)
    ?.tenant?.filter(tenant => formAnswer?.tenants?.some(userTenant => userTenant.id === tenant.id))
    ?.map(tenant => tenant.name)
    ?.join(', ') || '';

    return `${tenantNames} - ${approvalUser?.fullname || approvalUser?.name}`;
  }

  handleGetPortalUserName = (portalVal) => {
    const { portal_users_list } = this.props;

    if (portalVal.type === 'user' && portal_users_list?.length && portal_users_list.some(pUser => pUser.id === portalVal.id)) {
      return this.handleGetCompanyName(portalVal);
    }
    if (portalVal.type !== 'portal_user') {
      return portalVal?.fullname || portalVal?.name;
    }
      return this.handleGetCompanyName(portalVal);
  }

  checkAllUserCompleted = (step) => {
    const { formAnswer } = this.props;
    let assignedPersons = step?.assigned_persons || [];
    let roleAssignee = formAnswer?.role_assignee_info;
    let stepRoleAssignees = roleAssignee?.[step?.id];

    const usersFromRoles = stepRoleAssignees
      ? Object.values(stepRoleAssignees).flat()
      : [];
    if (assignedPersons.some(item => item?.id === 'initiator')) {
      assignedPersons = [...assignedPersons, formAnswer?.created_by];
    }
    assignedPersons = assignedPersons.filter(Boolean).filter(item => item.id !== 'initiator');
    if (step?.assigned_persons?.length > 0) {
      assignedPersons = step?.assigned_persons?.filter(item => item.type !== 'role');
    }
    const combinedPersons = [...assignedPersons, ...usersFromRoles];
    let uniqueAssignedPersons = Array.from(
      new Map(combinedPersons.filter(item => item !== null).map(item => [item.id, item])).values()
    );

    let approvals = formAnswer?.process?.approvals?.filter(item => item.step_id === step?.id && item.status === 'complete') || [];
    approvals = approvals?.filter(app => !formAnswer?.process?.info?.send_back_ids?.includes(app?.id));

    const allAssignedApproved = uniqueAssignedPersons.every(person => approvals.some(approval => approval.logged_by?.id === person.id));
    return allAssignedApproved;
  }

  handleOneUserPerRoleCondition = (step) => {
    const { formAnswer, profile } = this.props;

    const formInitiator = formAnswer?.created_by?.id;
    const sendBackIds = formAnswer?.process?.info?.send_back_ids ?? [];
    let roleAssignee = formAnswer?.role_assignee_info;
    let approvals = formAnswer?.process?.approvals;
    if (sendBackIds?.length) {
      approvals = approvals?.filter(app => !sendBackIds?.includes(app?.id));
    }
    let assignedPersons = formAnswer?.form_version?.process_def?.steps?.filter(st => (st?.id === step?.id))?.[0]?.assigned_persons || [];
    const listOfAssignees = formAnswer?.process?.approvals?.find(appr => appr.step_id === step?.id)?.step_assignees || [];
    if (listOfAssignees?.length) {
      assignedPersons = listOfAssignees;
    }

    let stepRoleAssignees = roleAssignee?.[step?.id];
    const usersFromRoles = stepRoleAssignees
      ? Object.values(stepRoleAssignees).flat()
      : [];
    const roleMap = {};
    const approvedByRole = {};

    Object.entries(stepRoleAssignees || {}).forEach(([roleId, users]) => {
      const roleName = assignedPersons.find(
        ap => ap.type === 'role' && String(ap.id) === String(roleId)
      )?.name;

      if (!roleName) return;

      users.forEach((user) => {
        if (!roleMap[user.id]) {
          roleMap[user.id] = [];
        }
        roleMap[user.id].push(roleName);
      });
    });

    assignedPersons = assignedPersons.filter(item => item.type !== 'role');
    const combinedPersons = [...assignedPersons, ...usersFromRoles];
    let uniqueAssignedPersons = Array.from(
      new Map(combinedPersons.map(item => [item.id, item])).values()
    );
    const matchFound = uniqueAssignedPersons?.some(item => item?.id === formInitiator);
    if (matchFound) {
      uniqueAssignedPersons = uniqueAssignedPersons
        .filter(Boolean).filter(item => item.id !== 'initiator')
        .map((item) => {
          const isInitiator = item?.id === formInitiator;
          const roles = roleMap[item.id] || [];

          return {
            ...item,
            isInitiator,
            roles,
            showInitiator: isInitiator
          };
        });
    } else {
      if (uniqueAssignedPersons.some(item => item?.id === 'initiator')) {
        uniqueAssignedPersons = [...uniqueAssignedPersons, formAnswer?.created_by];
      }
      uniqueAssignedPersons = uniqueAssignedPersons.filter(item => item?.id !== 'initiator')
      .filter(Boolean).map((item) => {
        const isInitiator = item?.fullname === formAnswer?.created_by?.fullname;
        const roles = roleMap[item.id] || [];

          return {
            ...item,
            isInitiator,
            roles,
            showInitiator: isInitiator
          };
      });
    }
    // Remove duplicate assignees based on id match
    uniqueAssignedPersons.filter((assignee, index, arr) => arr.findIndex(item => item.id === assignee.id) === index);

    (approvals || []).forEach((app) => {
      if (app.step_id !== step?.id) return;
      if (app.status !== 'complete') return;

      const approverId = app.logged_by?.id;
      const approverRoles = roleMap[approverId] || [];

      approverRoles.forEach((roleName) => {
        approvedByRole[roleName] = approverId;
      });
    });
    const allRoles = Array.from(
      new Set(
        uniqueAssignedPersons.flatMap(u => u.roles || [])
      )
    );

    const allRolesApproved = allRoles.length > 0 && allRoles.every(role => approvedByRole[role]);

    const myRoles = Object.keys(approvedByRole).length
      ? (formAnswer?.role_assignee_info?.[step?.id]
        && Object.entries(formAnswer.role_assignee_info[step.id])
          .filter(([, users]) => users.some(u => u.id === profile?.id))
          .map(([roleId]) => step?.assigned_persons?.find(
              ap => ap.type === 'role' && String(ap.id) === String(roleId)
            )?.name)
          .filter(Boolean)
        )
      : [];

    let myRoleApproved = false;
    myRoleApproved = myRoles.some(role => approvedByRole[role]);
    return { myRoleApproved, allRolesApproved };
  }

  getStepStatus = (step) => {
    const { formAnswer } = this.props;

    const formInitiator = formAnswer?.created_by?.id;
    const isCurrentStep = formAnswer?.process?.current_step?.split(',')?.includes(step?.id);
    let approvals = formAnswer?.process?.approvals;
    let roleAssignee = formAnswer?.role_assignee_info;
    let stepRoleAssignees = roleAssignee?.[step?.id];

    const usersFromRoles = stepRoleAssignees
      ? Object.values(stepRoleAssignees).flat()
      : [];
    if (formAnswer?.process?.info?.send_back_ids?.length) {
      approvals = approvals?.filter(app => !formAnswer?.process?.info?.send_back_ids?.includes(app?.id));
    }
    let assignedPersons = step?.assigned_persons.filter(item => item.type !== 'role');
    const matchFound = assignedPersons?.some(item => item?.id === formInitiator);
    if (matchFound) {
      assignedPersons = assignedPersons
        .filter(item => item?.id !== 'initiator');
    } else {
      if (assignedPersons.some(item => item?.id === 'initiator')) {
        assignedPersons = [...assignedPersons, formAnswer?.created_by];
      }
      assignedPersons = assignedPersons.filter(item => item?.id !== 'initiator');
    }
    const combinedPersons = [...assignedPersons, ...usersFromRoles];
    let uniqueAssignedPersons = Array.from(
      new Map(combinedPersons.filter(item => item !== null).map(item => [item.id, item])).values()
    );

    let completedApprovals = approvals?.filter(eachApp => eachApp?.step_id === step?.id && eachApp?.status === 'complete');
    const isAutoApproved = completedApprovals?.some(item => item.logged_by === null);
    if (isAutoApproved) {
      return 'completed';
    }

    const modes = {
      role: step?.role_approval_mode,
      user: step?.user_approval_mode
    };
    let allApproved = false;

    const roleModeAll = usersFromRoles.filter(Boolean)?.length
&& completedApprovals?.length ? usersFromRoles.filter(Boolean).every(assignee => completedApprovals.some(
        approval => approval.logged_by?.id === assignee.id
      )) : false;
    const roleModeAny = usersFromRoles.filter(Boolean)?.length
      && completedApprovals?.length ? usersFromRoles.filter(Boolean).some(assignee => completedApprovals.some(
        approval => approval.logged_by?.id === assignee.id
      )) : false;
    const roleModeUserPerRole = this.handleOneUserPerRoleCondition(step)?.allRolesApproved;

    const userModeAll = assignedPersons.filter(Boolean)?.length
      && completedApprovals?.length ? assignedPersons.filter(Boolean).every(assignee => completedApprovals.some(
        approval => approval.logged_by?.id === assignee.id
      )) : false;
    const userModeAny = assignedPersons.filter(Boolean)?.length
      && completedApprovals?.length ? assignedPersons.filter(Boolean).some(assignee => completedApprovals.some(
        approval => approval.logged_by?.id === assignee.id
      )) : false;

    if (modes.role === 'all' && (!modes.user || !assignedPersons.filter(Boolean)?.length)) {
      allApproved = roleModeAll;
    } else if (modes.role === 'any' && (!modes.user || !assignedPersons.filter(Boolean)?.length)) {
      allApproved = roleModeAny;
    } else if (modes.role === 'user_per_role' && (!modes.user || !assignedPersons.filter(Boolean)?.length)) {
      allApproved = roleModeUserPerRole;
    } else if (modes.user === 'all' && (!modes.role || !usersFromRoles.filter(Boolean)?.length)) {
      allApproved = userModeAll;
    } else if (modes.user === 'any' && (!modes.role || !usersFromRoles.filter(Boolean)?.length)) {
      allApproved = userModeAny;
    } else if (modes.role === 'all' && modes.user === 'all') {
      allApproved = roleModeAll && userModeAll;
    } else if (modes.role === 'all' && modes.user === 'any') {
      allApproved = roleModeAll && userModeAny;
    } else if (modes.role === 'any' && modes.user === 'all') {
      allApproved = roleModeAny && userModeAll;
    } else if (modes.role === 'any' && modes.user === 'any') {
      allApproved = roleModeAny && userModeAny;
    } else if (modes.role === 'user_per_role' && modes.user === 'all') {
      allApproved = roleModeUserPerRole && userModeAll;
    } else if (modes.role === 'user_per_role' && modes.user === 'any') {
      allApproved = roleModeUserPerRole && userModeAny;
    } else {
      allApproved = uniqueAssignedPersons.filter(Boolean)?.length
      && completedApprovals?.length ? uniqueAssignedPersons.filter(Boolean).every(assignee => completedApprovals.some(
        approval => approval.logged_by?.id === assignee.id
      )) : false;
    }
    if (!isCurrentStep && !allApproved) {
      return 'pending';
    }
    return allApproved ? 'completed' : 'awaiting';
  }

  handleStepFormDetail = (step, person) => {
    const { formAnswer } = this.props;
    const { editStepId } = this.state;

    const formInitiator = formAnswer?.created_by?.id;
    let approvals = formAnswer?.process?.approvals;
    let roleAssignee = formAnswer?.role_assignee_info;
    let stepRoleAssignees = roleAssignee?.[step?.id];

    const usersFromRoles = stepRoleAssignees
      ? Object.values(stepRoleAssignees).flat()
      : [];
    if (formAnswer?.process?.info?.send_back_ids?.length) {
      approvals = approvals?.filter(app => !formAnswer?.process?.info?.send_back_ids?.includes(app?.id));
    }
    let assignedPersons = step?.assigned_persons.filter(item => item.type !== 'role');
    const matchFound = assignedPersons?.some(item => item?.id === formInitiator);
    if (matchFound) {
      assignedPersons = assignedPersons
        .filter(item => item?.id !== 'initiator');
    } else {
      if (assignedPersons.some(item => item?.id === 'initiator')) {
        assignedPersons = [...assignedPersons, formAnswer?.created_by];
      }
      assignedPersons = assignedPersons.filter(item => item?.id !== 'initiator');
    }
    const combinedPersons = [...assignedPersons, ...usersFromRoles];
    let uniqueAssignedPersons = Array.from(
      new Map(combinedPersons.filter(item => item !== null).map(item => [item.id, item])).values()
    );

    let completedApprovals = approvals?.filter(eachApp => eachApp?.step_id === step?.id && eachApp?.status === 'complete');
    let hasSelfApproved = completedApprovals?.some(eachApp => eachApp?.logged_by?.id === person?.id);
    const isAutoApproved = completedApprovals?.some(item => item.logged_by === null);
    if (isAutoApproved) {
      return false;
    }

    const modes = {
      role: step?.role_approval_mode,
      user: step?.user_approval_mode,
      userAll: step?.all_users
    };
    let allApproved = false;
    const isRoleAssignee = usersFromRoles?.some(item => item?.id === person?.id);
    const isUserAssignee = assignedPersons?.filter(item => item !== null).some(item => item?.id === person?.id);

    const userInBothLists = usersFromRoles.some(u => u.id === person?.id)
    && assignedPersons.filter(item => item !== null).some(u => u.id === person?.id);

    const roleModeAll = usersFromRoles.filter(Boolean)?.length
      && completedApprovals?.length ? usersFromRoles.filter(Boolean).every(assignee => completedApprovals.some(
        approval => approval.logged_by?.id === assignee.id
      )) : false;
    const roleModeAny = usersFromRoles.filter(Boolean)?.length
      && completedApprovals?.length ? usersFromRoles.filter(Boolean).some(assignee => completedApprovals.some(
        approval => approval.logged_by?.id === assignee.id
      )) : false;
    const roleModeUserPerRole = this.handleOneUserPerRoleCondition(step)?.allRolesApproved;
    const myRoleApproved = this.handleOneUserPerRoleCondition(step)?.myRoleApproved;

    const userModeAll = assignedPersons.filter(Boolean)?.length
      && completedApprovals?.length ? assignedPersons.filter(Boolean).every(assignee => completedApprovals.some(
        approval => approval.logged_by?.id === assignee.id
      )) : false;
    const userModeAny = assignedPersons.filter(Boolean)?.length
      && completedApprovals?.length ? assignedPersons.filter(Boolean).some(assignee => completedApprovals.some(
        approval => approval.logged_by?.id === assignee.id
      )) : false;

    if (isRoleAssignee) {
      if (modes.role === 'all') allApproved = roleModeAll || hasSelfApproved;
      if (modes.role === 'any') allApproved = roleModeAny || hasSelfApproved;
      if (modes.role === 'user_per_role') allApproved = roleModeUserPerRole || myRoleApproved || hasSelfApproved;
    }

    if (isUserAssignee) {
      if (modes.userAll) {
        allApproved = userModeAll || hasSelfApproved;
      } else {
        allApproved = userModeAny || hasSelfApproved;
      }
      if (modes.user === 'all') allApproved = userModeAll || hasSelfApproved;
      if (modes.user === 'any') allApproved = userModeAny || hasSelfApproved;
    }

    if (userInBothLists) {
      if (modes.role === 'all' && modes.user === 'all') {
        allApproved = (roleModeAll && userModeAll) || hasSelfApproved;
      } else if (modes.role === 'all' && modes.user === 'any') {
        allApproved = (roleModeAll && userModeAny || hasSelfApproved);
      } else if (modes.role === 'any' && modes.user === 'all') {
        allApproved = (roleModeAny && userModeAll) || hasSelfApproved;
      } else if (modes.role === 'any' && modes.user === 'any') {
        allApproved = (roleModeAny && userModeAny) || hasSelfApproved;
      } else if (modes.role === 'user_per_role' && modes.user === 'all') {
        allApproved = ((roleModeUserPerRole || myRoleApproved) && userModeAll) || hasSelfApproved;
      } else if (modes.role === 'user_per_role' && modes.user === 'any') {
        allApproved = ((roleModeUserPerRole || myRoleApproved) && userModeAny) || hasSelfApproved;
      } else {
        allApproved = uniqueAssignedPersons.filter(Boolean)?.length
        && completedApprovals?.length ? uniqueAssignedPersons.filter(Boolean).every(assignee => completedApprovals.some(
          approval => approval.logged_by?.id === assignee.id
        )) : false;
      }
    }

    if (editStepId) {
      allApproved = false;
    }

    return !allApproved;
  }

  getIsSentBack = () => {
    const { formAnswer } = this.props;
    let sendBackInfo = formAnswer?.process?.additional_info?.send_back_info;
    const sendBackIds = formAnswer?.process?.info?.send_back_ids ?? [];
    let approvals = formAnswer?.process?.approvals;
    if (sendBackIds?.length) {
      approvals = approvals?.filter(app => !sendBackIds?.includes(app?.id));
    }
    const records = Object.values(sendBackInfo);
    const latestRecord = records.reduce((latest, current) => (new Date(current.send_back_date) > new Date(latest.send_back_date)
        ? current
        : latest));
    let condition = latestRecord?.send_back_step?.every(sent => approvals?.some(app => app?.step_id === sent));
    return condition;
  }

  handlePophover = (usedRecord, showPending, useText, stepStatus) => {
    const { popoverData, expandedStatus } = this.state;
    const { formAnswer } = this.props;
    const formInitiator = formAnswer?.created_by?.id;
    const sendBackIds = formAnswer?.process?.info?.send_back_ids ?? [];
    let approvals = formAnswer?.process?.approvals;
    if (sendBackIds?.length) {
      approvals = approvals?.filter(app => !sendBackIds?.includes(app?.id));
    }
    let popOverId = showPending ? usedRecord : usedRecord?.id;
    const step = formAnswer?.form_version?.process_def?.steps?.filter(item => item.id === popOverId)[0];
    let roleAssignee = formAnswer?.role_assignee_info;
    let stepRoleAssignees = roleAssignee?.[popOverId];
    const roleMap = {};
    const usersFromRoles = stepRoleAssignees
      ? Object.values(stepRoleAssignees).flat()
      : [];

    let assignedPersons = formAnswer?.form_version?.process_def?.steps?.filter(st => (st?.id === popOverId))?.[0]?.assigned_persons || [];
    const listOfAssignees = formAnswer?.process?.approvals?.find(appr => appr.step_id === popOverId)?.step_assignees || [];
    if (listOfAssignees?.length) {
      assignedPersons = listOfAssignees;
    }
    Object.entries(stepRoleAssignees || {}).forEach(([roleId, users]) => {
      const roleName = assignedPersons.find(
        ap => ap.type === 'role' && String(ap.id) === String(roleId)
      )?.name;

      if (!roleName) return;

      users.forEach((user) => {
        if (!roleMap[user.id]) {
          roleMap[user.id] = [];
        }
        roleMap[user.id].push(roleName);
      });
    });
    assignedPersons = assignedPersons.filter(item => item.type !== 'role');
    const matchFound = assignedPersons?.some(item => item?.id === formInitiator);
    if (matchFound) {
      assignedPersons = assignedPersons.filter(Boolean).filter(item => item.id !== 'initiator');
    } else {
      if (assignedPersons.some(item => item?.id === 'initiator')) {
        assignedPersons = [...assignedPersons, formAnswer?.created_by];
      }
      assignedPersons = assignedPersons.filter(item => item?.id !== 'initiator');
    }
    const combinedPersons = [...assignedPersons, ...usersFromRoles];
    let uniqueAssignedPersons = Array.from(
      new Map(combinedPersons.filter(item => item !== null).map(item => [item.id, item])).values()
    );

    uniqueAssignedPersons = uniqueAssignedPersons
      .filter(Boolean)
      .map((item) => {
        const isInitiator = (item?.id === formInitiator) || (item?.fullname === formAnswer?.created_by?.fullname);
        const roles = roleMap[item.id] || [];

        return {
          ...item,
          isInitiator,
          roles,
          showInitiator: isInitiator
        };
      });
    // Remove duplicate assignees based on id match
    uniqueAssignedPersons.filter((assignee, index, arr) => arr.findIndex(item => item.id === assignee.id) === index);

    const rejectInfo = formAnswer?.process?.info?.reject_info;
    const stepRejected = formAnswer?.process?.status === 'rejected'
      && rejectInfo?.step_id === popOverId;

    const rejectedBy = rejectInfo?.rejected_by;
    const approvedByRole = {};

    (approvals || []).forEach((app) => {
      if (app.step_id !== popOverId) return;
      if (app.status !== 'complete') return;

      const approverId = app.logged_by?.id;
      const approverRoles = roleMap[approverId] || [];

      approverRoles.forEach((roleName) => {
        approvedByRole[roleName] = approverId;
      });
    });

    const modes = {
      role: step?.role_approval_mode,
      user: step?.user_approval_mode,
      userAll: step?.all_users
    };

    const isRoleAssignee = person => usersFromRoles?.some(item => item?.id === person?.id);
    const isUserAssignee = person => assignedPersons?.filter(item => item !== null).some(item => item?.id === person?.id);
    const isBothAssignee = person => isRoleAssignee(person) && isUserAssignee(person);

    const getAssigneeStatus = (assignee, stepApprovals) => {
      const isCurrentStep = formAnswer?.process?.current_step?.split(',')?.includes(popOverId);
      let status;
      if (
        stepRejected
        && assignee?.fullname
        && assignee.fullname.replace(/\s*\(Initiator\)/, '').trim() === rejectedBy
      ) {
        return 'rejected';
      }

      const autoApproval = stepApprovals?.some(eachApp => !eachApp?.logged_by);
      if (autoApproval) return 'pending';
      if (!stepApprovals?.length > 0 && stepStatus !== 'sendBack' && isCurrentStep) return 'awaiting';

      const roleApprovals = stepApprovals?.length ? stepApprovals.filter(approval => usersFromRoles.some(
        user => approval.logged_by?.id === user.id
      )) : [];
      const userApprovals = stepApprovals?.length ? stepApprovals.filter(approval => assignedPersons?.filter(Boolean).some(
        user => approval.logged_by?.id === user.id
      )) : [];

      const assigneeApproved = stepApprovals?.some(eachApp => eachApp?.logged_by?.id === assignee?.id);
      if (assigneeApproved) {
        status = 'complete';
      } else {
        if (modes.role === 'all' && (!modes.user || !assignedPersons.filter(Boolean)?.length)) {
          status = 'awaiting';
        }
        if (modes.role === 'any' && (!modes.user || !assignedPersons.filter(Boolean)?.length)) {
          status = roleApprovals?.some(eachApp => eachApp.status === 'complete') ? 'pending' : 'awaiting';
        }
        if (modes.role === 'user_per_role' && (!modes.user || !assignedPersons.filter(Boolean)?.length)) {
          const assigneeRoles = assignee.roles || [];
          const approvedRole = assigneeRoles.find(r => approvedByRole[r]);

          if (approvedRole) {
            // Someone from my role approved
            status = approvedByRole[approvedRole] === assignee.id
              ? 'complete'
              : 'pending';
          } else {
            // No approval yet for this role
            status = 'awaiting';
          }
        }
        if ((modes.user === 'all' || modes.userAll) && (!modes.role || !usersFromRoles.filter(Boolean)?.length)) {
          status = 'awaiting';
        }
        if (modes.user === 'any' && (!modes.role || !usersFromRoles.filter(Boolean)?.length)) {
          status = userApprovals?.some(eachApp => eachApp.status === 'complete') ? 'pending' : 'awaiting';
        }
        if (modes.role === 'all' && (modes.user === 'all' || modes.userAll)) {
          status = 'awaiting';
        }
        if (modes.role === 'all' && modes.user === 'any') {
          if (isRoleAssignee(assignee)) status = 'awaiting';
          if (isUserAssignee(assignee)) status = userApprovals?.some(eachApp => eachApp.status === 'complete') ? 'pending' : 'awaiting';
          if (isBothAssignee(assignee)) status = 'awaiting';
        }
        if (modes.role === 'any' && (modes.user === 'all' || modes.userAll)) {
          if (isRoleAssignee(assignee)) status = roleApprovals?.some(eachApp => eachApp.status === 'complete') ? 'pending' : 'awaiting';
          if (isUserAssignee(assignee)) status = 'awaiting';
          if (isBothAssignee(assignee)) status = 'awaiting';
        }
        if (modes.role === 'any' && modes.user === 'any') {
          if (isUserAssignee(assignee)) status = userApprovals?.some(eachApp => eachApp.status === 'complete') ? 'pending' : 'awaiting';
          if (isRoleAssignee(assignee)) status = roleApprovals?.some(eachApp => eachApp.status === 'complete') ? 'pending' : 'awaiting';
        }
        if (modes.role === 'user_per_role' && (modes.user === 'all' || modes.userAll)) {
          if (isRoleAssignee(assignee)) {
            const assigneeRoles = assignee.roles || [];
            const approvedRole = assigneeRoles.find(r => approvedByRole[r]);

            if (approvedRole) {
              // Someone from my role approved
              status = approvedByRole[approvedRole] === assignee.id
                ? 'complete'
                : 'pending';
            } else {
              // No approval yet for this role
              status = 'awaiting';
            }
          }
          if (isUserAssignee(assignee)) status = 'awaiting';
          if (isBothAssignee(assignee)) status = 'awaiting';
        }
        if (modes.role === 'user_per_role' && modes.user === 'any') {
          if (isRoleAssignee(assignee)) {
            const assigneeRoles = assignee.roles || [];
            const approvedRole = assigneeRoles.find(r => approvedByRole[r]);

            if (approvedRole) {
              // Someone from my role approved
              status = approvedByRole[approvedRole] === assignee.id
                ? 'complete'
                : 'pending';
            } else {
              // No approval yet for this role
              status = 'awaiting';
            }
          }
          if (isUserAssignee(assignee)) status = userApprovals?.some(eachApp => eachApp.status === 'complete') ? 'pending' : 'awaiting';
          if (isBothAssignee(assignee)) {
            const assigneeRoles = assignee.roles || [];
            const approvedRole = assigneeRoles.find(r => approvedByRole[r]);

            if (approvedRole) {
              // Someone from my role approved
              status = approvedByRole[approvedRole] === assignee.id
                ? 'complete'
                : 'pending';
            } else {
              // No approval yet for this role
              status = 'awaiting';
            }
          }
        }
      }
      if (!isCurrentStep && status === 'awaiting' && stepStatus !== 'sendBack') {
        return 'pending';
      }
      if (!stepApprovals.length && stepStatus === 'sendBack' && !this.getIsSentBack()) {
          return stepStatus;
      }
      return status || 'pending';
    };

    let groupedByStatus = uniqueAssignedPersons.reduce((acc, assignee) => {
      let stepApprovals = approvals?.filter(eachApp => eachApp?.step_id === popOverId && eachApp?.status === 'complete');
      let status = getAssigneeStatus(assignee, stepApprovals);
      const assigneeApproval = stepApprovals?.find(app => app.logged_by?.id === assignee.id);

      acc[status] = acc[status] || [];
      acc[status].push({
        ...assignee,
        date:
          (status === 'complete' && assigneeApproval?.completed_date)
          || (status === 'rejected' && rejectInfo?.rejected_date)
          || null
      });
      return acc;
    }, {});

    const statusLabels = {
      complete: 'Completed By',
      rejected: 'Rejected By',
      awaiting: 'Awaiting from',
      pending: 'Pending',
      sendBack: 'Sent back'
    };

    const MAX_VISIBLE = 5;

    return (
    <Popover
      trigger="hover legacy"
      placement="right"
      isOpen={popoverData?.selectedPopStep === popOverId && popoverData?.isOpenPopover}
      target={`popover${popOverId}`}
      toggle={() => this.setState({ popoverData: {
        isOpenPopover: !popoverData?.isOpenPopover, selectedPopStep: popOverId
      } })}
      className={styles.desPopover}
    >
      <PopoverBody style={{
        padding: '10px 10px 10px 15px',
        maxHeight: '300px',
        overflowY: 'auto'
      }}>
        <span className={styles.popoverDes}>
          {['rejected', 'complete', 'pending', 'awaiting', 'sendBack'].map((status) => {
              const assignees = groupedByStatus[status] || [];
              const isExpanded = expandedStatus?.[status];
              const visibleAssignees = isExpanded
                ? assignees
                : assignees.slice(0, MAX_VISIBLE);
              const remainingCount = assignees.length - MAX_VISIBLE;
              return (
                groupedByStatus[status]?.length ? (
                  <div key={status} style={{ marginBottom: 10 }}>
                    <strong style={{ textTransform: 'capitalize' }}>
                      {statusLabels[status]}
                    </strong>
                    {visibleAssignees.map(assignee => (
                      <>
                        <div key={assignee.id} style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                          {/* Status Dot */}
                          {status === 'awaiting' && <span className={styles.awaitingDot} />}
                          {status === 'pending' && <span className={styles.pendingDot} />}
                          {status === 'complete' && <span className={styles.approvalDot} />}
                          {status === 'rejected' && <span className={styles.rejectDot} />}
                          {status === 'sendBack' && <span className={styles.sendBackDot} />}
                          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                            <span>
                              {this.handleGetPortalUserName({
                                ...assignee,
                                fullname: assignee.fullname
                              })}
                            </span>
                            {(status === 'complete' || status === 'rejected') && assignee.date && (
                              <span className={styles.dateLabel}>
                                {renderInfoForType({ type: 'datetime' }, assignee.date)}
                              </span>
                            )}
                          </div>
                        </div>
                        {(assignee.showInitiator || assignee.roles?.length > 0) && (
                          <span className={styles.roleText}>
                            {[
                              assignee.showInitiator && 'Initiator',
                              ...(assignee.roles || [])
                            ].filter(Boolean).join(', ') || ''}
                          </span>
                        )}
                      </>
                    ))}
                    {!isExpanded && remainingCount > 0 && (
                      <span
                        className={styles.moreText}
                        role="button"
                        tabIndex={0}
                        onClick={() => this.setState(prev => ({
                            expandedStatus: {
                              ...prev.expandedStatus,
                              [status]: true
                            }
                          }))
                        }
                        onKeyPress={(e) => {
                          if (e.key === 'Enter' || e.key === ' ') {
                            this.setState(prev => ({
                              expandedStatus: {
                                ...prev.expandedStatus,
                                [status]: true
                              }
                            }));
                          }
                        }}
                      >
                        +{remainingCount} more…
                      </span>
                    )}
                    {isExpanded && assignees.length > MAX_VISIBLE && (
                      <span
                        className={styles.lessText}
                        role="button"
                        tabIndex={0}
                        onClick={() => this.setState(prev => ({
                            expandedStatus: {
                              ...prev.expandedStatus,
                              [status]: false
                            }
                          }))
                        }
                        onKeyPress={(e) => {
                          if (e.key === 'Enter' || e.key === ' ') {
                            this.setState(prev => ({
                              expandedStatus: {
                                ...prev.expandedStatus,
                                [status]: false
                              }
                            }));
                          }
                        }}
                      >
                        Show less
                      </span>
                    )}


                  </div>
                ) : null
              );
            })}
          {useText && 'Click here to view details'}
        </span>
      </PopoverBody>
    </Popover>
    );
  }

  setAllSteps = () => {
    this.setState({ viewAllSteps: true,
       isShowTabDetails: true,
       sectionId: 'details_step',
       collpaseAll: true,
       useCollapseble: false
       },
    () => this.getCurrentStep());
  }

  viewCurrentStep = () => {
    const { formAnswer } = this.props;
    this.setState({ viewAllSteps: false,
       isShowTabDetails: true,
       sectionId: formAnswer?.process?.current_step?.split(',')?.[0],
       collpaseAll: false },
      () => this.getCurrentStep(true));
  }

  conditionDraft = (stepID, type) => {
    const { formAnswer, profile } = this.props;

    let approvalList = formAnswer?.process?.approvals || [];
    if (formAnswer?.process?.info?.send_back_ids?.length) {
      approvalList = approvalList?.filter(app => !formAnswer?.process?.info?.send_back_ids?.includes(app?.id));
    }
    if (!approvalList.length > 0) {
      return true;
    }

    const hasSelfApproved = approvalList.some(
      eachApp => eachApp?.logged_by?.id === profile?.id && eachApp.status === 'complete'
    );
    if (!approvalList.filter(eachApp => eachApp?.logged_by?.id === profile?.id
      && eachApp.status === 'complete' && eachApp?.step_id === stepID).length > 0) {
      return true;
    }
    if (hasSelfApproved && type === 'detail') return false;
    if (hasSelfApproved && type !== 'detail') return true;

    const matchedApp = approvalList.find((eachApp) => {
      const otherApprovers = eachApp.status === 'complete' && eachApp?.logged_by?.id !== profile?.id;
      const selfDraft = (eachApp.is_draft && eachApp?.logged_by?.id === profile?.id && eachApp?.status === 'awaiting');
      const othersDraft = (eachApp.is_draft && eachApp?.logged_by?.id !== profile?.id && eachApp?.status === 'awaiting');

      return otherApprovers || selfDraft || othersDraft;
    });
    return matchedApp;
  };

  handleProcessStatus = (stepId) => {
    const { formAnswer } = this.props;
    let statusCheck = false;
    let approveStep = formAnswer?.process?.approvals?.find(eachApp => eachApp?.step_id === stepId && eachApp?.status === 'complete');
    let useStep = formAnswer?.process?.info?.send_back_ids?.includes(approveStep?.id);
    if (useStep) {
      statusCheck = true;
    }
    if (!formAnswer?.process?.info?.path?.includes(stepId)) {
      statusCheck = true;
    }
    if (!approveStep) {
      statusCheck = true;
    }
    return statusCheck;
  }

  handleProcessSteps = (useId) => {
    const { formAnswer } = this.props;
    let approveStep = formAnswer?.process?.approvals?.find(eachApp => eachApp?.step_id === useId);
    let getSendBackSt = true;
    if (formAnswer?.process?.info?.send_back_ids?.length) {
      getSendBackSt = !formAnswer?.process?.info?.send_back_ids?.includes(approveStep?.id);
    }
    return getSendBackSt;
  }

  showCompletedBy = (stepUse) => {
    const { formAnswer } = this.props;
    return formAnswer?.process?.approvals?.find(eachApp => eachApp?.step_id === stepUse);
  }

  handleCollapseble = (viewType) => {
    this.setState({
      collpaseAll: viewType,
      useCollapseble: viewType,
      viewAllSteps: true,
      isShowTabDetails: true,
      sectionId: 'details_step'
    });
  }

  showIcon = () => {
    const { formAnswer } = this.props;
    let useThisIcon = this.images?.[formAnswer?.icon]?.default || 'icon-2.png';
    return useThisIcon;
  }

  handleReactToPrintCode = () => {
    const { profile, formAnswer } = this.props;
    return (
      <>
        <ReactToPrint
          onAfterPrint={() => this.setState({ isPrintPdf: false,
            actionDropdown: false,
            printDropdown: false })}
          style={{ display: 'block' }}
          onClick={() => this.setState({ isPrintWithoutData: false })}
          trigger={() => (
            <span
              translationID="workorders.detail"
              defaultText="Print Pdf"
              action="secondary"
            >
              <FormattedMessage
                id="workorders.detail"
                defaultMessage=" Default Print View"
              />
            </span>
          )}
          content={() => this.printComponentRef.current}
          documentTitle={`${profile?.airport?.name} (${profile?.airport?.code}) - ${formAnswer?.title}`}
        />
      </>
    );
  }

  handleGeneratePDF = async (pdfName, profile) => {
    this.setState({ loadingStatus: true });
    try {
      await generatePDF(pdfName, profile);
    } catch (error) {
      console.error('Error generating PDF:', error);
    } finally {
      this.setState({ loadingStatus: false });
    }
  };

  handleMultiField = (fieldId, data = []) => {
    const normalizedRows = normalizeMultiFieldRows(data, fieldId?.multiple_fields);
    return Object.keys(fieldId?.multiple_fields || {}).reduce((groupedResult, fieldKey) => {
      groupedResult[fieldKey] = normalizedRows.map(row => row?.[fieldKey]);
      return groupedResult;
    }, {});
  }

  getMultiFieldDetailData = (data = {}, fields = []) => {
    const detailData = { ...data };

    (fields || []).forEach((field) => {
      if (field?.type !== 'multi_field' || !field?.multiple_fields) return;
      const updatedRows = normalizeMultiFieldRows(detailData[field.id], field.multiple_fields);
      if (updatedRows.length > 0) {
        detailData[field.id] = updatedRows;
      }
    });

    return detailData;
  }

  tafInfo = (tafString) => {
    const lines = (tafString || '')
      .split('\n')
      .map(l => l?.trim())
      .filter(Boolean);
    const { tafExpanded } = this.state;
    // create unique keys even if lines repeat
    const keyCount = {};
    return lines.map((line) => {
      keyCount[line] = (keyCount[line] || 0) + 1;
      const uniqueKey = `${line}-${keyCount[line]}`;
      return (
        <p key={uniqueKey} className={styles.paragraph}>
          {line}
          {line === lines[lines.length - 1] && tafExpanded && (
            <button
              type="button"
              className={`${styles.showMore} ${styles.textButton} ${styles.showless}`}
              onClick={() => this.setState({ tafExpanded: false })}
            >
              <FormattedMessage
                id="inspections.answer_details.show_less"
                defaultMessage="Show Less"
              />
            </button>
          )}
        </p>
      );
    });
  };

  setTafExpanded = (boolean) => {
    this.setState({ tafExpanded: boolean });
  };

  render() {
    const { onlyCustomFields, userlist, profile, fromAdp, formAnswer, formAnswerLinked,
    actionFetchLinkedForms, locationList } = this.props;
    const {
      loadingStatus,
      newStepInfo,
      requiredMap,
      currentStep,
      showFormErrors,
      collpaseAll,
      sectionId,
      isShowTabDetails,
      viewAllSteps,
      viewCustomPrint,
      useCollapseble,
      formEntrySendBack,
      openSendBackDetails,
      printDropdown,
      isPrintPdf,
      errorsList,
      isPrintWithoutData,
      viewPrintOptions,
      printOptionSetting,
      tafExpanded,
      actionDropdown,
      errorListMCG
    } = this.state;
    const getPrintView = () => '@page { size: auto; }';
    const getStyles = () => '@page { margin: 80px 50px !important; }';

    const renderWeatherObs = obs => (obs !== undefined
      ? `${obs.metar.summary} - ${obs.metar.temperature}${obs.metar.wind !== undefined ? `, ${obs.metar.wind}` : ''
      }${obs.metar.humidity !== undefined
        ? `, Humidity - ${obs.metar.humidity}`
        : ''
      }`
      : '');
    const tafDecoded = formAnswer?.weather_conditions?.current_obs?.tafDecoded;
    const checkTabVisiblity = tabCheck => (isShowTabDetails && !viewAllSteps ? sectionId === tabCheck.tabId : true);
    const orderedSteps = this.getSortedSteps(formAnswer?.form_version?.process_def?.steps || []);
    const printSetting = formAnswer?.settings?.enable_print_option && formAnswer?.settings?.printshowSetting;

    const printStep = orderedSteps?.find(
      step => `${step?.id}` === `${printSetting}`
    );

    let showPrintButton = true;

    if (formAnswer?.process?.id) {
      if (!printSetting) {
        showPrintButton = true;
      } else if (printSetting === 'all') {
        showPrintButton = formAnswer?.process?.current_step === 'closed';
      } else {
        showPrintButton = !!printStep && this.getStepStatus(printStep) === 'completed';
      }
    }
    let customPrintTemplate = formAnswer?.latest_version?.print_templates || {};
    const isAttachamentsAvailable = formAnswer?.form_version?.schema?.fields?.some(attachField => attachField.type === 'attachments');
    const mapShowing = formAnswer?.form_version?.schema?.fields?.some(field => (
      field?.type === 'map_location'
      || (
        field?.dataSourceID === 'ds2'
        && (
          field?.type?.includes?.('MultiLevel')
          || field?.type === 'multi-level-location'
          || field?.type === 'dataSourceMultiLevel'
        )
      )
    ));
    if (formAnswer && formAnswer.form_version && formAnswer?.key && customPrintTemplate
      && Object.keys(customPrintTemplate)?.length > 0) {
      let newObj = {};
      if (formAnswer.form_version.schema?.fields) {
        formAnswer.form_version.schema.fields.map((eachField) => {
          if (eachField.type === 'attachments' || eachField?.type === 'signature') {
            newObj = {
              ...newObj,
              [eachField.id]: formAnswer?.data[eachField.id]?.[0]?.url
            };
          } else if (eachField.type === 'boolean') {
            newObj = {
              ...newObj,
              isfieldChecked: formAnswer?.data[eachField.id] ? 'checked' : '',
              [eachField.id]: formAnswer?.data[eachField.id] ? 'checked' : ''
            };
          } else if (eachField?.type === 'dataSource' && eachField?.dataSourceID === 'ds6') {
            newObj = {
              ...newObj,
              [eachField.id]: renderInfoForType(eachField, formAnswer?.data[eachField.id], formAnswer?.form_version, true, null) || '',
              [`${eachField.id}_img`]: formAnswerLinked?.data?.[eachField?.id]?.[0]?.url || ''
            };
          } else if (eachField.type === 'multiselect') {
            newObj = {
              ...newObj,
              [eachField.id]: eachField?.values?.filter((val) => {
                if (Array.isArray(formAnswer?.data[eachField.id])) {
                return formAnswer?.data[eachField.id]
                ?.filter(selectKey => selectKey === val.key)?.length > 0;
                }
                return null;
              })?.map(newVal => newVal?.value)
            };
          } else {
            newObj = {
              ...newObj,
              [eachField.id]: renderInfoForType(eachField, formAnswer?.data[eachField.id], formAnswer?.form_version, true, null) || ''
            };
          }
          if (formAnswer?.key && JSON.stringify(formAnswer?.key)) {
            newObj = {
              ...newObj,
              qr_code: ReactDOMServer.renderToStaticMarkup(<QRcode id="FormQRcode"
                value={`Form ${formAnswer?.key}`}
                size={300} />)
            };
          }
          if (eachField.type === 'date') {
            const totalDate = formAnswer?.data[eachField.id];
            const total = new Date(totalDate);
            const DateValue ={
              formDate: total.getDate(),
              formMonth: total.getMonth(),
              formYear: total.getFullYear()
            };
              newObj = {
                ...newObj,
              [eachField.id]: DateValue
              };
          }
          return eachField;
        });
      }
      if (formAnswer.process.approvals?.length > 0) {
        formAnswer.process.approvals.map((eachSign) => {
          let stepFields = formAnswer?.form_version?.process_def?.steps?.find(st => eachSign.step_id === st.id)?.fields;
          if (stepFields?.length > 0) {
            stepFields.map((eachOne) => {
                if (eachOne.type === 'attachments') {
                  newObj ={
                    ...newObj,
                    approvals_fields: {
                      ...newObj.approvals_fields,
                      [eachSign.step_id]: {
                        ...newObj.approvals_fields?.[eachSign.step_id],
                        attachmentUrl: eachSign.data?.[eachOne.id]?.[0]?.url
                      }
                    }
                  };
                }
                if (eachOne.type === 'signature') {
                  newObj ={
                    ...newObj,
                    approvals_fields: {
                      ...newObj.approvals_fields,
                      [eachSign.step_id]: {
                        ...newObj.approvals_fields?.[eachSign.step_id],
                        signature: eachSign.data?.[eachOne.id]?.[0]?.url
                      }
                    }
                  };
                }
                if (eachOne.type === 'boolean') {
                  newObj = {
                    ...newObj,
                    approvals_fields: {
                      ...newObj.approvals_fields,
                      [eachSign.step_id]: {
                        ...newObj.approvals_fields?.[eachSign.step_id],
                        isfieldChecked: eachSign?.data?.[eachOne.id] ? 'checked' : '',
                        [eachOne.id]: eachSign?.data?.[eachOne.id] ? 'checked' : ''
                      }
                    }
                  };
                } else if (eachOne.type === 'multiselect') {
                  newObj = {
                    ...newObj,
                    approvals_fields: {
                      ...newObj.approvals_fields,
                      [eachSign.step_id]: {
                        ...newObj.approvals_fields?.[eachSign.step_id],
                        [eachOne.id]: eachOne?.values?.filter(val => eachSign?.data?.[eachOne.id]
                          ?.filter(selectKey => selectKey === val.key)?.length > 0)?.map(newVal => newVal?.value)
                      }
                    }
                    };
                } else {
                  newObj = {
                    ...newObj,
                    approvals_fields: {
                      ...newObj.approvals_fields,
                      [eachSign.step_id]: {
                        ...newObj.approvals_fields?.[eachSign.step_id],
                      [eachOne.id]: renderInfoForType(eachOne, eachSign?.data?.[eachOne.id],
                        { schema: { fields: stepFields || [] } }, true, null) || ''
                      }
                    }
                  };
                }
              return eachOne;
            });
          }
          newObj ={
            ...newObj,
            approvals_fields: {
              ...newObj.approvals_fields,
              [eachSign.step_id]: {
                ...newObj.approvals_fields?.[eachSign.step_id],
                approverName: eachSign.logged_by?.fullname,
                approverDesignation: eachSign.logged_by?.roles?.[0]?.name,
                remarkComment: eachSign?.comment,
                remarkAttachmentUrl: eachSign?.attachments?.[0]?.url,
                completedDate: renderInfoForType({ type: 'datetime' }, eachSign?.completed_date, null, null)
              }
            }
          };
          return eachSign;
        });
      }
      const multiFieldData = formAnswer?.form_version?.schema?.fields?.filter(field => field.type==='multi_field');
      formAnswer.printTemplateData = {
      ...newObj,
      airport_name: formAnswer?.airport_name || '',
      portal_tenant: formAnswer?.portal_tenant || '',
      createdBy: formAnswer?.created_by?.fullname || formAnswer?.created_by?.first_name,
      createdDate: renderInfoForType({ type: 'datetime' }, formAnswer?.created_at, null, null),
      logo: profile?.portal_airport?.logo,
      formTitle: `${formAnswer?.title} #${moment(
          formAnswer?.form_date
        ).format('YY')} - ${formAnswer?.order_number}`,
      multiGridFields: multiFieldData?.reduce((a, v) => ({ ...a, [v?.id]: v?.multiple_fields }), {})
      };
      formAnswer.generateQRcode = generateQRcode;
      // using multigrid fields and multiple images
      formAnswer.showMultiImg = generateImges;
      formAnswer.showGridTable = showGridTable;
    }
    let printTemplateList = customPrintTemplate || {};
    const pdfName = `${formAnswer.title} #${
      formAnswer?.settings?.auto_increment_field_def?.enable_auto_gen_as_form_id && formAnswer.auto_gen
        ? formAnswer.auto_gen
        : `${moment(formAnswer.form_date).format('YY')} - ${formAnswer.order_number}`
    }`;
    const detailData = this.getMultiFieldDetailData(
      formAnswer?.data || {},
      formAnswer?.form_version?.schema?.fields || []
    );

    return (
      <>
        <Loading loadingStatus={loadingStatus} />
        {formAnswer && Object.keys(formAnswer).length > 0 && (
          <>
            {!onlyCustomFields && !fromAdp
            && <>
                <SectionHeader
                  icon={this.showIcon()}
                  translationID="invalid"
                  defaultTitle={`${formAnswer.title} #${formAnswer?.settings?.auto_increment_field_def?.enable_auto_gen_as_form_id
                    && formAnswer.auto_gen ? formAnswer.auto_gen : `${moment(formAnswer.form_date).format('YY')} - ${
                    formAnswer.order_number
                    }`
                    } `}
                >
                   <div className={styles.detailHeader}>
                    {printTemplateList && printTemplateList?.[Object.keys(printTemplateList)?.[0]]?.templateData && (
                      <>
                      {showPrintButton
                       && (formAnswer?.settings?.form_print_settings && formAnswer?.settings?.form_print_settings === 'default_print'
                        && formAnswer?.settings?.form_print_settings !== 'both') && (
                        <Clickable
                          className={formAnswer?.process?.id ? styles.actionsBtn : styles.usePrint}
                          onClick={async () => {
                            const extractDs6Keys = (data, fields = []) => fields
                                .filter(field => field.dataSourceID === 'ds6')
                                .flatMap((field) => {
                                  const value = data?.[field.id];
                                  if (Array.isArray(value)) {
                                    return value.map(i => i?.detailId).filter(Boolean);
                                  }
                                  return value?.detailId ? [value.detailId] : [];
                                });

                            let ds6FormKeys = extractDs6Keys(
                              formAnswer?.data,
                              formAnswer?.form_version?.schema?.fields
                            );

                            for (const approval of formAnswer?.process?.approvals || []) {
                              const approvalStep = formAnswer?.form_version?.process_def?.approvals?.steps
                                ?.find(step => step?.id === approval?.step_id);

                              if (approvalStep?.fields) {
                                ds6FormKeys.push(...extractDs6Keys(approval?.data, approvalStep.fields));
                              }
                            }

                            if (ds6FormKeys?.length > 0 && !formAnswerLinked?.id) {
                              await actionFetchLinkedForms(ds6FormKeys[0]);
                            }
                            this.setState({ viewCustomPrint: !viewCustomPrint });
                          }}
                        >
                          <FormattedMessage
                            defaultMessage="Print"
                            id="my_forms.print.label"
                          />
                        </Clickable>
                      )}
                        {formAnswer?.process?.id && (<Separator />)}
                      </>
                    )}
                    {formAnswer?.process?.id && (
                      <>
                        <Clickable
                          className={styles.actionsBtn}
                          onClick={() => this.setState({ openSendBackDetails: true })}
                        >
                          <FormattedMessage
                            id="workorders.remarks"
                            defaultMessage="Remarks"
                          />
                        </Clickable>
                        <Separator />
                        {!viewAllSteps && (
                          <Clickable
                            className={styles.actionsBtn}
                            onClick={() => this.setAllSteps()}
                          >
                            <FormattedMessage
                              id="forms.detail.collapse_all"
                              defaultMessage="All Steps"
                            />
                          </Clickable>
                        )}
                        {viewAllSteps && formAnswer?.process?.current_step !== 'closed' && (
                          <Clickable
                            className={styles.actionsBtn}
                            onClick={() => this.viewCurrentStep()}
                          >
                            <FormattedMessage
                              id="forms.detail.awaiting_approval"
                              defaultMessage="Awaiting Approval"
                            />
                          </Clickable>
                        )}
                        {viewAllSteps && formAnswer?.process?.current_step === 'closed' && (
                          !useCollapseble
                           ?<Clickable
                              className={styles.actionsBtn}
                              onClick={() => this.handleCollapseble(true)}
                            >
                              <FormattedMessage
                                id="forms.detail.expan_all"
                                defaultMessage="Collapse All"
                              />
                            </Clickable>
                          : <Clickable
                              className={styles.actionsBtn}
                              onClick={() => this.handleCollapseble(false)}
                            >
                              <FormattedMessage
                                id="forms.detail.collapse_all"
                                defaultMessage="Expand All"
                              />
                            </Clickable>
                        )}
                      </>
                    )}
                    {actionDropdown && (
                      <ul
                        className={`${styles.dropdown} ${
                          actionDropdown ? `${styles.open} ${styles.actionWidth}` : ''
                        }`}
                      >
                            {formAnswer?.settings?.edit_tenant_access_for_portal === true
                              && <li className={styles.item}>
                                    <Clickable
                                      onClick={() => this.goToEditForm(formAnswer.key)}
                                    >
                                      <FormattedMessage
                                        id="inspections.step0.edit"
                                        defaultMessage="Edit"
                                      />
                                    </Clickable>
                                 </li>}
                            <li className={styles.item}>
                              <Clickable
                                onClick={() => this.duplicateFormEntry(formAnswer)}
                                onKeyPress={() => this.duplicateFormEntry(formAnswer)}
                              >
                                <FormattedMessage
                                  id="workorders.detail.duplicate"
                                  defaultMessage="Duplicate"
                                />
                              </Clickable>
                            </li>
                      </ul>
                    )}
                    {showPrintButton && (formAnswer?.settings?.form_print_settings === 'custom_print'
                    || formAnswer?.settings?.form_print_settings !== 'default_print')
                    && (formAnswer?.settings?.form_print_settings !== 'both') && (
                      <>
                        <Separator />
                        <Clickable
                          className={styles.actionsBtn}
                          onClick={() => this.setState({
                              printDropdown: !printDropdown,
                              isPrintPdf: !isPrintPdf,
                              isPrintWithoutData: false
                            })
                          }
                        >
                          <FormattedMessage
                            id="workorders.detail"
                            defaultMessage="Print"
                          />
                        </Clickable>
                      </>
                    )}
                    <Separator />
                    <Clickable
                      className={styles.actionsBtn}
                      onClick={() => this.setState({ actionDropdown: !actionDropdown, isPrintPdf: !isPrintPdf, isPrintWithoutData: true })
                      }
                    >
                      <FormattedMessage
                        id="workorders.detail.actionBtn"
                        defaultMessage="Actions"
                      />
                    </Clickable>
                    {printDropdown && (
                      <ul
                        className={`${styles.dropdownprintDefault} ${
                          printDropdown
                            ? `${styles.open} ${styles.actionWidth}`
                            : ''
                        }`}
                      >
                      {(formAnswer?.settings?.form_print_settings !== 'default_print' && formAnswer?.settings?.form_print_settings !== 'both') && (
                        <li className={styles.item} role="presentation">
                          {isAttachamentsAvailable ? (
                            <span
                              translationID="workorders.detail"
                              defaultText="Print Pdf"
                              action="secondary"
                              onClick={() => {
                                this.setState({
                                  viewPrintOptions: true,
                                  printOptionSetting: 'at_the_beginning'
                                });
                                this.handlePrintContent = this.printSecondComponentRef?.current;
                              }}
                              onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                  e.preventDefault();
                                  this.setState({
                                    viewPrintOptions: true,
                                    printOptionSetting: 'at_the_beginning'
                                  });
                                  this.handlePrintContent = this.printSecondComponentRef?.current;
                                }
                              }}
                              role="button"
                              tabIndex={0}
                            >
                              <FormattedMessage
                                id="workorders.detai"
                                defaultMessage=" Default Print View"
                              />
                            </span>
                          ) : (
                            this.handleReactToPrintCode(isAttachamentsAvailable)
                          )}
                        </li>
                      )}
                      {!formAnswer?.settings?.form_print_settings
                      && printTemplateList && printTemplateList[Object.keys(printTemplateList)?.[0]]?.printViewImage && (
                        <li className={styles.item} role="presentation">
                           <ReactToPrint
                            onAfterPrint={() => this.setState({ viewCustomPrint: false })}
                            trigger={() => (
                              <span
                              translationID="workorders.detail.pdfBnt"
                              defaultText="Print"
                              action="secondary"
                            >
                            <FormattedMessage
                              id="workorders.detail"
                              defaultMessage=" Custom Print View"
                            />
                              </span>
                            )}
                            content={() => this.printCustomTemplateRef.current}
                            documentTitle={
                              `${profile?.portal_airport?.name}
                              (${profile?.portal_airport?.code}) - ${formAnswer?.title}`}
                          />
                        </li>)}
                        <li
                          role="presentation"
                          className={styles.item}
                          onClick={() => this.handleGeneratePDF(pdfName, profile)}
                        >
                          <span
                            role="button"
                            tabIndex="0"
                            onClick={() => this.setState({ isPrintWithoutData: false })
                            }
                            onKeyPress={(e) => {
                              if (e.key === 'Enter' || e.key === ' ') {
                                this.setState({ isPrintWithoutData: false });
                              }
                            }}
                            style={{
                              cursor: 'pointer',
                              marginBottom: '15px',
                              marginTop: '20px',
                              marginLeft: '10px'
                            }}
                          >
                            <FormattedMessage
                              id="workorders.detail.download"
                              defaultMessage="Download"
                            />
                          </span>
                        </li>
                        <Modal
                          onClose={() => this.setState({ viewPrintOptions: false })
                          }
                          showIn={viewPrintOptions}
                          width="25%"
                          minHeight="30%"
                        >
                          <div
                            className={styles.printTitle}
                            style={{ marginBottom: '0px' }}
                          >
                            <h3>
                              <FormattedMessage
                                id="operations.builder.send_email"
                                defaultMessage="Print Settings"
                              />
                            </h3>
                            <div
                              onClick={() => this.setState({ viewPrintOptions: false })
                              }
                              role="presentation"
                            >
                              <img
                                src={CloseIcon}
                                style={{
                                  cursor: 'pointer',
                                  marginRight: '0px',
                                  width: '25px'
                                }}
                                alt="close"
                              />
                            </div>
                          </div>
                          <div
                            className="container"
                            style={{
                              paddingBottom: '30px',
                              paddingTop: '30px'
                            }}
                          >
                            <PulpoField
                              key="print_option"
                              id="print_option"
                              type="select"
                              translationID="form.step1.print_option"
                              title="Embed Attachments:"
                              widget={{ type: 'radio' }}
                              handleValueChange={(a) => {
                                this.setState({ printOptionSetting: a });
                                this.handlePrintContent = a === 'at_the_end'
                                    ? this.printComponentRef.current
                                    : this.printSecondComponentRef.current;
                              }}
                              answer={printOptionSetting}
                              isRequired
                              handleFieldErrorChanged={() => {}}
                              showFieldErrors={false}
                              values={[
                                {
                                  key: 'at_the_beginning',
                                  value: ' At the Beginning'
                                },
                                { key: 'at_the_end', value: 'At the End' }
                              ]}
                            />
                          </div>
                          <div
                            className={styles.footer}
                            style={{ gap: '20px' }}
                          >
                            <Button
                              translationID="inspections.new.cancelBtn"
                              defaultText="Cancel"
                              action="tertiary"
                              onClick={() => {
                                this.setState({
                                  viewPrintOptions: !viewPrintOptions
                                });
                              }}
                            />
                            {viewPrintOptions && (
                              <ReactToPrint
                                onAfterPrint={() => this.setState({
                                    isPrintPdf: false,
                                    actionDropdown: false,
                                    printDropdown: false,
                                    selectedPopStep: '',
                                    openDefaultPrint: false,
                                    isOpenPopover: false,
                                    viewPrintOptions: false
                                  })
                                }
                                style={{ display: 'block' }}
                                onClick={() => this.setState({ isPrintWithoutData: false })
                                }
                                trigger={() => (
                                  <Button
                                    className={styles.saveBtn}
                                    translationID="workorders.detail.Print"
                                    defaultText="Print"
                                    action="secondary"
                                  />
                                )}
                                content={() => (isAttachamentsAvailable
                                    ? this.handlePrintContent
                                    : this.printComponentRef.current)
                                }
                                documentTitle={`${profile?.airport?.name} (${profile?.airport?.code}) - ${formAnswer?.title}`}
                              />
                            )}
                          </div>
                        </Modal>
                      </ul>
                    )}
                    <div
                      style={
                        mapShowing
                          ? {
                              opacity: 0,
                              transform: 'scale(0.001)',
                              height: '1px',
                              position: 'fixed'
                            }
                          : { display: 'none' }
                      }
                    >
                      {isPrintPdf && (
                        <div ref={this.printComponentRef}>
                          <style>{getStyles()}</style>
                          <DefaultPrintTemplate
                            formAnswer={formAnswer}
                            formImage
                            isPrintWithoutData={isPrintWithoutData}
                            EndOfthePage
                            mcgHeader
                          />
                        </div>
                      )}
                      {isPrintPdf && (
                        <div ref={this.printSecondComponentRef}>
                          <style>{getStyles()}</style>
                          <DefaultPrintTemplate
                            formAnswer={formAnswer}
                            formImage
                            isPrintWithoutData={isPrintWithoutData}
                            RelatedField
                            mcgHeader
                          />
                        </div>
                      )}
                    </div>
                    {printTemplateList && printTemplateList[Object.keys(printTemplateList)?.[0]]?.templateData && (
                      <div style={{ display: 'none' }}>
                        <div ref={this.printCustomTemplateRef} className={styles.printCustom}>
                          <style>{getPrintView()} </style>
                          <style>{getStyles()}</style>
                          <div
                            // eslint-disable-next-line react/no-danger, no-eval, prefer-template
                            dangerouslySetInnerHTML={{ __html: eval('`'
                            + printTemplateList[Object.keys(printTemplateList)?.[0]]?.templateData + '`') }}
                          />
                        </div>
                      </div>
                    )}
                    {viewCustomPrint && (
                      <ul className={`${styles.dropdownprint} ${
                        viewCustomPrint ? `${styles.open} ${styles.actionWidth}` : ''
                        }`}
                      >
                        <li className={styles.item}>
                          {printTemplateList && printTemplateList[Object.keys(printTemplateList)?.[0]]?.printViewImage
                          && (
                            <div>
                              <div style={{}}>
                                <ReactToPrint
                                  onAfterPrint={() => this.setState({ viewCustomPrint: false })}
                                  trigger={() => (
                                    <span
                                    translationID="workorders.detail.pdfBnt"
                                    defaultText="Print"
                                    action="secondary"
                                  >
                                  <FormattedMessage
                                    id="workorders.detail"
                                    defaultMessage=" Custom Print View"
                                  />
                                    </span>
                                  )}
                                  content={() => this.printCustomTemplateRef.current}
                                  documentTitle={
                                    `${profile?.portal_airport?.name}
                                    (${profile?.portal_airport?.code}) - ${formAnswer?.title}`}
                                />
                              </div>
                            </div>
                            )}
                        </li>
                      </ul>
                    )}
                   </div>
                </SectionHeader>
                <HeaderBack
                  translationID="form.start.back"
                  translationDefault="Back to Forms"
                  backRoute={this.URL}
                  exactRoute={this.URL}
                  myForms
                >
                  {formAnswer?.process?.id && (
                    <div>
                      <ul className={styles.workflowStatusColors}>
                        <li className={styles.statusItem}>
                          <div className={styles.awaitingDot} />
                          <FormattedMessage
                            id="forms.detail.awaiting_approval"
                            defaultMessage="Awaiting Approval"
                          />
                        </li>
                        <li className={styles.statusItem}>
                          <div className={styles.pendingDot} />
                          <FormattedMessage
                            id="forms.detail.pending_approval"
                            defaultMessage="Pending Approval"
                          />
                        </li>
                        <li className={styles.statusItem}>
                          <div className={styles.approvalDot} />
                          <FormattedMessage
                            id="forms.detail.complete"
                            defaultMessage="Completed"
                          />
                        </li>
                        <li className={styles.statusItem}>
                          <div className={styles.rejectDot} />
                          <FormattedMessage
                            id="forms.detail.rejected"
                            defaultMessage="Rejected"
                          />
                        </li>
                        <li className={styles.statusItem}>
                          <div className={styles.sendBackDot} />
                          <FormattedMessage
                            id="forms.new.enable_send_back"
                            defaultMessage="Send Back With Data"
                          />
                        </li>
                      </ul>
                    </div>
                  )}
                </HeaderBack>
               </>
            }
            <div style={{ display: 'flex' }}>
              {formAnswer?.process?.id && (
                <div className={`${styles.sideContainer} col-md-2`}>
                  <div className={`${styles.stepInfo} ${styles.noMarginTop}`}>
                    <div className={styles.infoHalf} style={{ borderTop: '1px solid #e6eaee' }}>
                      <h3 style={{ display: 'flex', marginBottom: '0px' }}>
                        <FormattedMessage
                          id="forms.detail.process"
                          defaultMessage="Process"
                          tagName="h3"
                        />
                        {formAnswer?.process?.status === 'rejected' && (
                          <div className={collaspeSty.reject}>
                            <FormattedMessage
                              id="forms.detail.rejected"
                              defaultMessage="Rejected"
                              tagName="p"
                            />
                          </div>
                        )}
                        {formAnswer?.process?.status === 'in_progress' && (
                          <div className={collaspeSty.in_progress}>
                            <FormattedMessage
                              id="forms.detail.rejected"
                              defaultMessage="In Progress"
                              tagName="p"
                            />
                          </div>
                        )}
                        {formAnswer?.process?.status === 'complete' && (
                          <div className={collaspeSty.complete}>
                            <FormattedMessage
                              id="forms.detail.complete"
                              defaultMessage="Completed"
                              tagName="p"
                            />
                          </div>
                        )}
                      </h3>
                    </div>
                    <div className={styles.infoHalf}
                      style={{ borderBottom: '1px solid #e6eaee',
                               borderTop: 'none',
                               cursor: 'pointer',
                               background: !viewAllSteps && sectionId === 'details_step' ? 'aliceblue' : 'none'
                            }}
                      onClick={() => this.handleShowTab('details_step')}
                      role="presentation"
                    >
                      <div
                        id={`popover${formAnswer?.process?.id}`}
                        style={{ cursor: 'pointer', display: 'flex' }}
                        className={collaspeSty.pointerSty}
                      >
                        <h3 style={{ display: 'flex' }}>
                          <FormattedMessage
                            id="forms.step2.created_details"
                            defaultMessage="Requested Form Details"
                            tagName="h3"
                          />
                        </h3>
                      </div>
                      {this.handlePophover(formAnswer?.process?.id, 'pending', true)}
                    </div>
                  </div>
                  <div className={`${styles.stepInfo} ${styles.noMarginTop}`}>
                  {orderedSteps?.map(step => step.node_id !== '0'
                  && (
                    <>
                      {formAnswer?.process?.current_step?.split(',')?.includes(step.id)
                      && (getApprovalMode(step) === 'all' ? (this.conditionDraft(step.id)) : true) && this.getStepStatus(step) === 'awaiting'
                      && formAnswer?.process?.info?.reject_info?.step_id !== step.id
                      && (
                        <>
                        {this.handleShowStepVisible(step, this.getStepStatus(step))}
                        </>
                      )}

                      {!formAnswer?.process?.current_step?.split(',')?.includes(step.id)
                      && this.handleProcessStatus(step.id)
                      && formAnswer?.process?.info?.reject_info?.step_id !== step.id
                      && !formAnswer?.settings?.hide_pending_approval_steps
                      && (
                        this.handleShowStepVisible(step,
                          !formAnswer?.process?.approvals?.some(
                            app => app?.step_id === step.id && app?.status === 'send_back_loop'
                          ) || this.getIsSentBack() ? 'pending' : 'sendBack')
                      )}

                      {(getApprovalMode(step) === 'all' || step?.role_approval_mode === 'any' || step?.user_approval_mode === 'any') ? (
                        <>
                          {formAnswer?.process?.approvals?.find(
                            eachApp => eachApp?.step_id === step.id
                          )?.step_id && this.getStepStatus(step) === 'completed'
                            && formAnswer?.process?.info?.reject_info?.step_id !== step.id
                            && this.handleShowStepVisible(step, this.getStepStatus(step))}
                        </>
                      ) : (
                        <>
                          {formAnswer?.process?.approvals?.find(eachApp => eachApp?.step_id === step.id)?.step_id
                            && this.handleProcessSteps(step?.id)
                            && formAnswer?.process?.current_step?.split(',')?.[0] !== step.id
                            && !formAnswer?.process?.current_step?.split(',')?.includes(step.id)
                            && (
                              this.handleShowStepVisible(step, 'completed')
                          )}
                        </>
                      )}

                      {formAnswer?.process?.status === 'rejected'
                      && formAnswer?.process?.info?.reject_info?.step_id === step.id
                      && (
                        this.handleShowStepVisible(step, 'rejected')
                      )}
                    </>
                  ))}
                  </div>
                </div>
              )}
              <div
                className={formAnswer?.process?.id ? 'col-md-8' : ''}
                style={formAnswer?.process?.id ? {} : { margin: '0 auto' }}
              >
                {this.displayFormEntry() && sectionId === 'details_step' && (
                  <div className={`${styles.minWidthContainer}`} style={onlyCustomFields ? { marginTop: '0px' } : {}}>
                    <Collapsible
                      title={formAnswer?.process?.id ? 'Requested Form Details' : 'Details'}
                      styleClasses={collaspeSty.collapsibleHeader}
                      autoheight
                      openOnMount={formAnswer?.process?.id ? collpaseAll: false}
                      collapsibleHeight="0"
                    >
                      <div className={`${styles.stepInfo} ${styles.noMarginTop}`}>
                        {!onlyCustomFields &&(
                          <>
                            {formAnswer.source !== FORM_PUBLIC_STATUS && (
                              <div className={styles.infoHalf} style={{ borderTop: '1px solid #e6eaee' }}>
                                <span>
                                  <FormattedMessage
                                    id="forms.step2.created_by"
                                    defaultMessage="Created By"
                                  />
                                </span>
                                <p>{formAnswer?.created_by?.fullname}</p>
                              </div>
                            )}
                            {formAnswer.source === FORM_PUBLIC_STATUS && (
                              <>
                                <div className={styles.infoHalf} style={{ borderTop: '1px solid #E6EAEE', borderBottom: 'none' }}>
                                  <span>
                                    <FormattedMessage
                                      id="forms.step2.source"
                                      defaultMessage="Source"
                                    />
                                  </span>
                                  <p>Public Form</p>
                                </div>
                                {formAnswer.public_user
                                  && Object.keys(formAnswer.public_user).map(f => (
                                    <>
                                      {f !== 'none' && formAnswer.public_user[f] === true && (
                                        <div key={f.id} className={styles.infoHalf} style={{ borderTop: '1px solid #E6EAEE', borderBottom: 'none' }}>
                                          <span>{f}</span>
                                          <p>{formAnswer.public_user_info[f]}</p>
                                        </div>
                                      )}
                                    </>
                                  ))}
                              </>
                            )}
                            <div className={styles.infoHalf} style={{ borderTop: '1px solid #e6eaee' }}>
                              <span>
                                <FormattedMessage
                                  id="forms.step2.created_date"
                                  defaultMessage="Created By"
                                />
                              </span>
                              <p>
                                {renderInfoForType({ 'type': 'datetime' }, formAnswer.form_date, null, null)}
                              </p>
                            </div>
                            {formAnswer?.weather_conditions?.current_obs&&(
                              <div key="weather_obs" className={styles.infoFull}>
                                <FormattedMessage
                                  id="inspections.answer_details.weatherobservation"
                                  defaultMessage="Weather Observations"
                                />
                                <div className={styles.info}>
                                  <FormattedMessage
                                    id="inspections.answer_details.metar.info"
                                    defaultMessage="METAR - "
                                  />
                                  <div className={styles.answer}>
                                    {renderWeatherObs(
                                      formAnswer?.weather_conditions?.current_obs
                                    )}
                                  </div>
                                </div>
                                {formAnswer?.weather_conditions?.current_obs?.metarRaw && formAnswer?.settings?.get_metar_raw_info && (
                                  <React.Fragment>
                                    <div className={styles.info}>
                                      <FormattedMessage
                                        id="inspections.answer_details.metar.raw.info"
                                        defaultMessage="METAR RAW - "
                                      />
                                      <div className={styles.answer}>
                                        {formAnswer?.weather_conditions?.current_obs?.metarRaw}
                                      </div>
                                    </div>
                                    <div className={`${styles.info} ${styles.taf_con}`}>
                                      <FormattedMessage
                                        id="inspections.answer_details.taf.info"
                                        defaultMessage="TAF - "
                                      />
                                      <div className={styles.answer}>
                                        {`${(tafDecoded || '')?.split('\n')[0]}${!tafExpanded && !!tafDecoded ? '...' : ''}`}
                                        {!tafExpanded && !!tafDecoded && (
                                          <button
                                            type="button"
                                            tabIndex="0"
                                            className={`${styles.showMore} ${styles.textButton}`}
                                            onClick={() => this.setTafExpanded(true)}
                                          >
                                            <FormattedMessage
                                              id="inspections.answer_details.show_more"
                                              defaultMessage="Show More"
                                            />
                                            {' '}
                                          </button>
                                        )}
                                      </div>
                                    </div>
                                  </React.Fragment>
                                )}
                                {tafExpanded && (
                                  <div className={styles.taf_info_modal_con}>
                                    {this.tafInfo(tafDecoded)}
                                  </div>
                                )}
                              </div>
                            )}
                          </>
                        )}
                      </div>
                      <CustomFieldDetail
                        data={detailData}
                        version={formAnswer.form_version}
                        fields={formAnswer.form_version?.schema?.fields?.filter(each => !each?.disable_for_portal && each.type !== 'ssi_field') || []}
                        profile={profile}
                        FormDetails
                        enabled_zoomed
                        mcgHeader
                        showMultiColTitle
                      />
                    </Collapsible>
                  </div>
                )}
                {this.getSortedSteps(formAnswer?.form_version?.process_def?.steps)?.map(mainStep => mainStep.node_id !== '0' && (
                  <div>
                    {requiredMap && currentStep?.id === mainStep?.id
                    && checkTabVisiblity({ tabId: currentStep?.id })
                    && (getApprovalMode(mainStep) === 'all' ? this.conditionDraft(mainStep?.id, 'detail') : true)
                    && this.handleStepFormDetail(mainStep, profile)
                    && (
                      <div className={styles.stepContainer}>
                        <StepForm
                          info={newStepInfo}
                          collpaseAll={false}
                          userlist={userlist}
                          profile={profile}
                          step={currentStep}
                          requiredMap={requiredMap}
                          errorsList={errorsList}
                          showFormErrors={showFormErrors}
                          handleSubmit={this.handleSubmitApprove}
                          handleReject={this.handleReject}
                          searchForUser={this.handleSearchForUser}
                          handleSendBack={this.handleSendBack}
                          handleUploadAttachments={this.handleUploadAttachments}
                          handleAnswerChanged={(value, id, c) => this.handleInfoChanged('newStepInfo', id, value, c)}
                          handleFieldErrorChanged={(value, id) => this.handleInfoChanged('fieldErrors', value, id)}
                          showTabDetails={isShowTabDetails}
                          sectionId={sectionId}
                          handleCheckListAnswer={this.handleCheckListAnswer}
                          form_entry_data={formAnswer?.data}
                          formAnswerSettings={formAnswer?.settings}
                          formApprovalProcess={formAnswer?.process?.approvals}
                          processStep={formAnswer?.process}
                          formEntryDetails={formAnswer}
                          errorListMCG={errorListMCG}
                          locationList={locationList}
                          process_def={formAnswer?.form_version?.process_def?.steps}
                        />
                      </div>
                    )}
                    {(() => {
                        const allApproved = currentStep && Object.keys(currentStep).length > 0 && this.checkAllUserCompleted(currentStep);
                        let condition = false;
                        const sendBackIds = formAnswer?.process?.info?.send_back_ids ?? [];
                        if (allApproved) {
                          condition = allApproved;
                        } else {
                          condition = formAnswer?.process?.approvals?.filter(item => (
                            item.status === 'complete'
                            && !this.handleStepFormDetail(mainStep, profile)
                            && item?.step_id === currentStep?.id
                            && !sendBackIds?.includes(item?.id)
                          )).length > 0;
                        }
                        const allUsersApproved = (getApprovalMode(currentStep) === 'all') ? condition : true;
                        const autoApproved = formAnswer?.process?.approvals?.filter(app => app.logged_by === null && app.status === 'complete'
                          && app.step_id === mainStep?.id) || [];

                        const collapsibleTitle = autoApproved.length > 0 ? 'Auto Approved' : 'Approval';
                        let approvalList = formAnswer?.process?.approvals?.filter(approveStep => (
                          approveStep.step_id === mainStep?.id && !approveStep.is_draft && allUsersApproved
                          && (approveStep?.status === 'complete' || approveStep?.status === 'send_back_loop')
                        )) || [];
                        if (sendBackIds?.length && !approvalList?.some(approve => approve?.status === 'send_back_loop')) {
                          approvalList = approvalList?.filter(app => !sendBackIds?.includes(app?.id));
                        }
                        const infoBoxes = approvalList
                          .filter(approve => this.checkVisibility(approve?.step_id)
                            && checkTabVisiblity({ tabId: approve.step_id }))
                          .map(approve => (
                            <div style={{ marginBottom: '10px', width: '95%' }}>
                              <StepInfoBox
                                key={approve?.step_id}
                                info={approve || {}}
                                step={formAnswer?.form_version?.process_def?.approvals?.steps?.filter(step => (
                                  step?.id === approve?.step_id
                                ))?.[0]}
                                collpaseAll={collpaseAll}
                                collapsibleTitle={approve?.logged_by?.fullname || collapsibleTitle}
                                profile={profile}
                                formAnswerSettings={formAnswer?.settings}
                                form_entry_data={formAnswer?.data}
                                formApprovalProcess={formAnswer?.process?.approvals}
                              />
                            </div>
                          ));
                        return infoBoxes.length > 0 ? (
                          <Panel title={mainStep?.title} containerClasses={styles.panelContainer}>
                            {infoBoxes}
                          </Panel>
                        ) : null;
                      })()}
                  </div>
                ))}
                  {openSendBackDetails && (
                    <Modal
                      onClose={() => this.setState({ openSendBackDetails: false })}
                      showIn={openSendBackDetails}
                      width="60%"
                      minHeight="60%"
                    >
                      <div>
                        <div className={collaspeSty.rejectionModalTitle}>
                          <FormattedMessage
                            id="workorders.remarks"
                            defaultText="Remarks"
                            tagName="h3"
                          />
                            <button className={`${collaspeSty.closeIcon} ${collaspeSty.useStyBorder}`}
                              onClick={() => this.setState({ openSendBackDetails: false })}
                            >&times;
                            </button>
                        </div>
                        <div className={collaspeSty.rejectionModalContent} style={{ height: '30rem', overflow: 'auto' }}>
                          <CommentContainer
                            comments={formAnswer?.historys}
                            myForms
                          />
                        </div>
                        <div className={collaspeSty.rejectionActionButton}>
                          <Button
                            translationID="workorders.list.filters.views.cancel"
                            defaultText="Cancel"
                            action="tertiary"
                            className={collaspeSty.cancelButton}
                            onClick={() => this.setState({ openSendBackDetails: false })}
                          />
                          {formEntrySendBack === 'step_1' && (
                            <Button
                              translationID="workorders.list.filters.views.cancel"
                              defaultText="Edit form data"
                              action="secondary"
                              className={collaspeSty.cancelButton}
                              onClick={() => this.goToEditForm(formAnswer?.key)}
                            />
                          )}
                        </div>
                      </div>
                    </Modal>
                  )}
                  <div id="directDownload" className={styles.directDownload}>
                   <style>{getStyles()}</style>
                   <DefaultPrintTemplate
                    formAnswer={formAnswer}
                    formImage
                    isPrintWithoutData={isPrintWithoutData}
                    EndOfthePage
                    mcgHeader
                   />
                  </div>
              </div>
            </div>
          </>
        )}
        <div className={styles.bottomStyle} />
      </>
    );
  }
}

MyformDetails.propTypes = {
  history: PropTypes.shape({}).isRequired
};

const mapStateToProps = state => ({
  formAnswer: state.forms?.formAnswerDetails,
  fetchAnswerAction: state.forms?.formAnswerDetailAction,
  portal_users_list: state.forms?.portal_users_list,
  userlist: state?.inspection?.userlist,
  profile: state.auth?.profile,
  get_custom_template_data: state.form?.form,
  formApproveAction: state.forms?.formApprovalAction,
  formRejectionAction: state.forms?.formRejectionAction,
  sendBackAction: state.forms.formSendbackAction,
  dataSourceValues: state.inspection.dataSourceValues,
  formAnswerLinked: state.forms?.linkedFormAnswerDetails,
  formAnswerLinkedAction: state.forms?.fetchLinkedAnswerAction,
  locationList: state.forms?.getFormsSchema?.locations
});

const mapDispatchToProps = dispatch => ({
  actionFetch: (id) => {
    dispatch(fetchFormAnswerDetails(id));
  },
  actionApprovalStep: (data, id) => {
    dispatch(submitApproval(data, id));
  },
  actionRejectApproval: (id, data) => {
    dispatch(rejectApproval(id, data));
  },
  actionSendBack: (id, data) => {
    dispatch(approvalSendBack(id, data));
  },
  actionSendBackWithData: (id, data) => {
    dispatch(approvalSendBackWithData(id, data));
  },
  actionClearFormDetails: () => {
    dispatch(actionClearForm());
  },
  fetchPortalUsersList: () => {
    dispatch(getPortalusersForPortaUserlField());
  },
  acitonGetTabView: () => {
    dispatch(actionSaveTabView('history'));
  },
  actionFetchLinkedForms: (data) => {
    dispatch(fetchDataSourceFormDetails(data));
  },
  actionFetchFormSchema: (data) => {
    dispatch(getPortalFormSchema(data));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(MyformDetails);
